import { EVENTS, INTERNAL_EVENTS, SDK_EVENTS } from '../constants/events.cnst';
import { ClassMapConstanst, IdMapConstant, ProjConstants, RenderResponseType, storageConst, Tabs } from '../constants/projConsts'
import { getHTML } from '../templatemanager/base/domManager';
import { FaqAnswerPlacement, FaqExpandCloseBtn } from '../templatemanager/tabs/suggestions/faq/faq';
import { handleSendCopyButtons, ActionButtonsSentText, handleSendCopyButtonsForNodes } from '../templatemanager/tabs/atom/actionButtons';
import RandomuuidPipe from '../utils/randomuuid';
import KoreGenerateuuidPipe from '../utils/koregenerateuuid';
import { AskCustomer, AttachmentAskCustomer, DialogEnd, DialogStart, ExpandButtonForEntity, FeedbackWrapperInsideDialog, MybotAttachmentAskCustomer, ReduceButtonForEntity, TellCustomer } from '../templatemanager/tabs/automation/automation';
import { HelpfulFeedbackSection, NegativeFeedbackSection } from '../templatemanager/tabs/feedback/feedback';
import fetchInstance from '../utils/interceptor';
import {FeebackConst} from '../constants/settingsConsts';
import { DEFAULT_FEEDBACK_SETTINGS, DEFAULT_WIDGET_SETTINGS } from '../constants/default.config';
import { ErrorHandler } from '../templatemanager/tabs/ErrorBoundary/ErrorHandler';
import DOMPurify from 'dompurify';
import { safeScrollDimensions, safeDimensions } from '../../../utils/domUtils';

export class rootService {

    isAutomationOnGoing : boolean = false;
    isMyBotAutomationOnGoing : boolean = false;
    currentAutomationId : string = '';
    currentMybotAutomationId  : string = '';
    isCustomTabAutomationOnGoing : boolean = false;
    currentCustomTabAutomationId: string = '';
    grantResponseObj: any = {};
    isInitialInternalTransferTriggered : boolean = false;

    prefsAccessObj: any = {
        tabsNTitles: [],
        prefs: {},
        orderTabs: [],
        defaultTab : ""
    };

    customTabPrefsObj:any ={
        customTabEnabled: false,
        customTabPrefs : {},
        customTabWlD : [],
        customTablbl: ''
    }

    prefsOpacity:any;

    connectionDetails: any = {};

    aaSettings: any = {};

    menuResponseArr:any = [];

    numOfLines: any = 4;
    maxHeight: any = 'max-content';
    scrollHeight: any = Number.MAX_VALUE;

    classConstants : any = ClassMapConstanst;
    idConstants : any = IdMapConstant;

    faqambiguityResponse : boolean = false;

    activeTab : string = '';

    internalTransfer : boolean = false;
    internalTransferData : any = {};

    placeholderTextSearch:any;
    proactiveMode : boolean = false;
    OverRideMode : boolean = false;
    manualAssistOverrideMode : boolean = false;

    autoScrollStatus : boolean = true;
    isOnReadyCalled : boolean = false;
    agenticStart : boolean = false;

    myBotTabSessionId : any = '';
    assistTabSessionId : any = '';
    sentSearchResponse : boolean = false;
    searchedResultData : any = {};

    socketConnect : boolean = false;
    tabsNTitles:any = [];

    isAnonymousFlowEnabled : boolean = false;
    isAnonymousFlowTriggered : boolean = false;
    isHooksApi : boolean = false;
    isAgenticCoPilotEnabled : boolean = false;
    isAgenticPaused : boolean = false;
    isAgenticAutoSendEnabled : boolean = true;
    sendingTimeForAgenticAutoSend : number = 5000;
    timerForSendingAgenticAutoSend : any;

    isPlaybookHistory: boolean = false;
    selCLInx: any;
    selStInx: any;
    selSpInx: any;
    isProceedToClose : boolean = false;
    dynClObjs : any = {};
    DialogsinGroups:any ={};

    hideActionButtons : boolean = false;
    hideSendButton : boolean = false;
    hideCopyButton : boolean = false;

    isUpdateFeedBackDetailsFlag : boolean = false;
    moreBtnActive : boolean = false;

    tabs = {
        ast: ProjConstants.ASSIST,
        mB: ProjConstants.MYBOT,
        srch: ProjConstants.SEARCH,
        trnspt: ProjConstants.TRANSCRIPT
    };
    tabsTitleAsKey = {
        [ProjConstants.ASSIST]: 'ast',
        [ProjConstants.MYBOT]: 'mB',
        [ProjConstants.SEARCH]: 'srch',
        [ProjConstants.TRANSCRIPT]: 'trnspt'
    };

    widgetFeedbackData = {
        selectedSuggestions: [] as string[],
        comment: '',
        type: '',
        positionId: ''
    };

    isWidgetFeedbackAPICalled : boolean = false;
    widgetHistoryType: string = ''

    entitiesValueArray: any = [];
    mybotEntitiestValueArray : any = [];

    interruptDialogList : any = [];
    mybotInterruptDialogList : any = [];
    customInterruptDialogList : any = [];
    isExitEventTriggered : boolean = false;


    menuResponse : any = [];

    isGroups:boolean = false;

    isHistory:boolean = true;

    customTabHistoryData:any = [];

    aaHelpers : any;

    disableWidgetFlag : boolean = false;

    defaultFeedbackSettings : any = DEFAULT_FEEDBACK_SETTINGS;
    defaultSuggestionObj : any = DEFAULT_WIDGET_SETTINGS;

    tableList = ['table', 'tableList', 'custom_table'];
    realtimeSentiData : any = {
        
    };
    isSummariesGenerated : boolean = false;
    generatedSummaries : any = [];
    maxIntSummaryCount: number = 2;
    currentGenIntSummaryCount: number = 0;
    summaryInProgress = false;
    finalSummaryGenerated = false;
    hiddenClasses : any = [];
    summaryStatus : number = 200;
    summaryRetryCount : number = 0;
    interimSummary: boolean = false;
    customTabEntitiesValueArray: any[] = [];

    agenticNodeArray: any[] = [];


    currCl:any = '';
    currSt:any = '';
   


    constructor(hostInstance : any) {
        this.aaHelpers = hostInstance.chatWindowInstance.helpers;  
        this.handleEmptyLine = this.handleEmptyLine.bind(this);        
    }

    sanitizeHTML(html: string) {
        const config = {
            ADD_ATTR: ['target', 'rel'], // Allow target and rel attributes
            ALLOWED_ATTR: ['href', 'target', 'rel', 'class'], // Common link attributes
            ALLOW_DATA_ATTR: true,
            FORCE_BODY: true,
            ALLOWED_TAGS: ['a', 'p', 'span', 'b', 'i', 'em', 'strong', 'br'], // Common HTML tags
        };
        return DOMPurify.sanitize(html, config);
    }

    updateDefaultFeedbackData() {
        const categories = Object.keys(this.defaultFeedbackSettings);
    
        categories.forEach(category => {
          const languages = Object.keys(this.defaultSuggestionObj[category]);
          this.defaultFeedbackSettings[category].negativeKeyWords = {};
    
          languages.forEach(language => {
            const langArray = this.defaultSuggestionObj[category][language].map((element : any, index : number) => ({
              isEnabled: index <= 4,
              key: element
            }));
            this.defaultFeedbackSettings[category].negativeKeyWords[language] = langArray;
          });
        });
      }

    formatSearchResponse(response: any, isSearch = false, suggestionIndex : number, suggestionFrom = ProjConstants.MYBOT) {
        let suggestions = response.suggestions;
        let dialoguesArray = suggestions.dialogs || [];
        let faqArray = suggestions.faqs || [];
        let snippersArray = this.formatSnippetResponse(suggestions?.searchassist?.snippets || [], response, suggestionIndex)
        let filesArray = suggestions?.searchassist?.files || [];
        let searchResponse: any = {};
        if (suggestions?.searchassist && suggestions?.searchassist?.snippets && suggestions?.searchassist?.snippets?.length == 0) {
            delete suggestions.searchassist.snippets;
        }
        let searchassistKeys = Object.keys(suggestions?.searchassist || {});
        if (suggestions?.searchassist && searchassistKeys?.length == 1 && searchassistKeys[0] === 'searchRequestId') {
            suggestions.searchassist = {};
        }
        if (dialoguesArray.length || faqArray.length || snippersArray.length || filesArray.length || (suggestions?.searchassist && Object.keys(suggestions?.searchassist)?.length)) {
            searchResponse.dialogs = [];
            searchResponse.faqs = [];
            searchResponse.articles = [];
            searchResponse.snippets = [];
            searchResponse.files = [];
            if (suggestions.searchassist && Object.keys(suggestions.searchassist)?.length > 0) {
                for (let source in suggestions.searchassist) {
                    if (source != "snippets" && source != "file" && source != 'searchRequestId') {
                        suggestions.searchassist[source] = this.checkEmptyObjectsInArray(suggestions.searchassist[source]);
                        if (suggestions.searchassist[source] && Object.keys(suggestions.searchassist[source])?.length > 0) {
                            searchResponse.articles.push.apply(searchResponse.articles, suggestions.searchassist[source]);
                        }
                    }
                    if (source == "file") {
                        suggestions.searchassist[source] = this.checkEmptyObjectsInArray(suggestions.searchassist[source]);
                        if (suggestions.searchassist[source] && Object.keys(suggestions.searchassist[source])?.length > 0) {
                            searchResponse.files.push.apply(searchResponse.files, suggestions.searchassist[source]);
                        }
                    }
                    if (source && source != 'searchRequestId') {
                        suggestions?.searchassist[source]?.forEach((item: any) => {
                            item.subType = source;
                        });
                    }
                }
                for (let article of searchResponse.articles) {
                    article.showMoreButton = true;
                    article.showLessButton = false;
                    article.content = article.content ? article.content : '';
                    article.contentId = article.contentId;
                    article.userInput = response.userInput;
                    article.sourceMsgId = response.sourceMsgId || '';
                    article.subType = article.subType;
                    article.intType = isSearch ? 'mybot' : 'assist';
                    article.feedbackData = this.prepareFeedbackForSuggestions('article', article, {})
                }
                for (let file of searchResponse.files) {
                    file.showMoreButton = true;
                    file.showLessButton = false;
                    file.content = file.content ? file.content : '';
                    file.contentId = file.contentId;
                    file.userInput = response.userInput;
                    file.sourceMsgId = response.sourceMsgId || '';
                    file.subType = file.subType;
                    file.intType = isSearch ? 'mybot' : 'assist';
                    file.feedbackData = this.prepareFeedbackForSuggestions('file', file, {})
                }
            }

            for (let faq of faqArray) {
                let faqObject: any = {
                    question: faq.question,
                    displayName: faq.displayName,
                    taskRefId: faq?.taskRefId,
                    answer: (faq.answer && faq.answer.length > 0) ? [] : false,
                    showMoreButton: true,
                    showLessButton: false,
                    answerRender: faq.answer || false,
                    childBotId: faq.childBotId,
                    childBotName: faq.childBotName,
                    answerCount: 1,
                    sourceMsgId: response.sourceMsgId || '',
                    positionId: faq.positionId,
                    userInput: response.userInput,
                    intType: response.intType
                }
                if (faq.answer && faq.answer.length > 0) {
                    for (let ans of faq.answer) {
                        let object: any = {
                            ans: ans,
                            taskRefId: faq.taskRefId,
                            showMoreButton: true,
                            showLessButton: false,
                            displayName: faq.displayName,
                            sourceMsgId: response.sourceMsgId || '',
                            positionId: faq.positionId
                        }
                        faqObject.answer.push(object);
                    }
                }
                let feedbackData = faq.historyFeedback ? faq.historyFeedback : {};
                faqObject.feedbackData = this.prepareFeedbackForSuggestions('faqs', faqObject, feedbackData);
                faqObject.feedbackData.interactionType = isSearch ? 'mybot' : 'assist';
                searchResponse.faqs.push(faqObject);
            }
            if (suggestions?.searchassist?.snippets?.length > 0) {
                if (snippersArray?.length > 0) {
                    searchResponse.snippets = Object.assign([], snippersArray);
                }
                for (let snippet of searchResponse.snippets) {
                    snippet.showMoreButton = true;
                    snippet.showLessButton = false;
                    snippet.subType = 'snippets';
                }
            }

            for (let dialog of dialoguesArray) {
                if (dialog.entities && dialog.entities?.length > 0) {
                    dialog.entities.forEach((entity: any) => {
                        entity.editMode = false;
                    });
                }
                searchResponse.dialogs.push({
                    intentName: dialog.name,
                    childBotId: dialog.childBotId,
                    childBotName: dialog.childBotName,
                    entities: dialog.entities,
                    userInput: response.userInput,
                    sourceMsgId: response.sourceMsgId || '',
                    positionId : RandomuuidPipe('positionId'),
                    traits : response.traits || [],
                    dialogId : dialog.dialogId ? dialog.dialogId : this.matchDialogIdfromMenuResponse(dialog),
                    suggestionFrom : suggestionFrom || ProjConstants.MYBOT
                });
            }
        }
        return searchResponse;
    }

    formatSnippetResponse(snippetsArray: any, response: any, suggestionIndex : number) {
        let snipObje: any = {};
        snipObje['contentArray'] = [];
        snipObje['sources'] = [];
        snipObje['internalInfo'] = [];
        snipObje['sendCopyText'] = '';
        let snippetResponeArray: any = [];
        if (snippetsArray?.length > 0) {
            snippetsArray.forEach((snippet: any) => {
                if (snippet?.templateType) {
                    if (snippet.templateType == 'active_citation_snippet' || snippet.templateType == 'citation_snippet') {
                        if (
                            snippet?.content &&
                            Array.isArray(snippet?.content) &&
                            snippet?.content?.length > 0
                        ) {
                            snippet.content.forEach((ansSnippet: any) => {
                                let ansObj = {
                                    ans: ansSnippet.answer_fragment,
                                    sources: ansSnippet?.sources || [],
                                    internalFlag: snippet.internalFlag
                                };
                                snipObje['contentArray'].push(ansObj);
                                snipObje.internalFlag = snippet.internalFlag || false;
                                snipObje.isActCit = true;
                            });
                        }
                    } else {
                        if (snippet?.content) {
                            if (Array.isArray(snippet?.content)) {
                                snippet.content = snippet?.content.join('\n');
                            }
                            snipObje.internalFlag = snippet.internalFlag || false;
                            let otherType: any = {
                                ans: snippet.content,
                                internalFlag: snippet.internalFlag
                            }
                            if (snippet.url) {
                                otherType['sources'] = [{ title: snippet.source, url: snippet.url }];
                            }
                            snipObje.contentArray.push(otherType);
                        }
                    }
                    snipObje.templateType = snippet.templateType;
                    snipObje.positionId = snippet.positionId;
                    snipObje.sourceMsgId = response.sourceMsgId || '';
                    snipObje.intType = response.intType;
                    snipObje.isFromGeneratedSummary = response.isFromGeneratedSummary;
                    snipObje.userInput = response.userInput || '';
                }
            });
            let extInfo = '';
            let interlInfo = ''
            let uniqueSource: any = [];
            snipObje['contentArray']
                ?.forEach((entry: any) => {
                    let className = '';
                    snipObje.sources.push(
                        ...(entry?.sources || []).filter((item: any) => {
                            let returnValue = item.url && uniqueSource.indexOf(item.title) == -1;
                            if (returnValue) {
                                uniqueSource.push(item.title);
                            }
                            if (uniqueSource.indexOf(item.title) != -1) {
                                className += `fragment-ext-${uniqueSource.indexOf(item.title) + 1}-${suggestionIndex}`;
                            }
                            return returnValue;
                        })
                    );

                    if (!entry.internalFlag) {
                        snipObje['sendCopyText'] += entry.ans;
                    }
                    let temp = `<span class="${className}">${entry.ans} `;
                    if (Array.isArray(entry?.sources) && entry?.sources?.length) {
                        for (let source of entry?.sources) {
                            if (source?.title && uniqueSource.indexOf(source?.title) != -1) {
                                let srcCount = uniqueSource.indexOf(source.title);
                                temp += `<span class="source-count-num">${srcCount + 1}</span>`;
                            }
                        }
                    }
                    temp += '</span>';
                    if (entry.internalFlag) {
                        interlInfo += temp;
                    } else {
                        extInfo += temp;
                    }
                });
            snipObje['contentArray'] = [];
            snipObje['internalInfo'] = [];
            if (interlInfo?.trim()) {
                snipObje['internalInfo'].push(interlInfo?.trim());
            }
            if (extInfo?.trim()) {
                snipObje['contentArray'].push(extInfo?.trim());
            }
            snipObje.feedbackData = this.prepareFeedbackForSuggestions('answer', snipObje, {})
            snippetResponeArray.push(snipObje);
        }
        return snippetResponeArray;
    }

    updateSearchResponse(assistResponseArray: any, response: any, ambiguityTokenExt: any) {
        response.suggestions.faqs = this.formatFAQResponse(response.suggestions.faqs);

        const faqWithoutAnswerIndex = response?.suggestions?.faqs?.findIndex((faq : any, index : number) => {
            if (faq.question === ambiguityTokenExt.question) {
                return faq;
            }
        });

        let faqWithoutAnswer : any = {};

        if(faqWithoutAnswerIndex >= 0){
            faqWithoutAnswer = response?.suggestions?.faqs[faqWithoutAnswerIndex];
        }

        if(faqWithoutAnswer && Object.keys(faqWithoutAnswer)?.length > 0){
            const updatedArray = assistResponseArray.map((item: any, idx: number) => {
                if (idx === ambiguityTokenExt.assistSuggestion) {
                    const updatedItem = { ...item };
                    let existingFaq : any = updatedItem.searchResponse?.faqs[ambiguityTokenExt.index];
                    if(existingFaq && faqWithoutAnswer && faqWithoutAnswer?.answer){
                        existingFaq.answer = faqWithoutAnswer?.answer;
                        existingFaq.toggle = true;
                        existingFaq.showMoreButton = false;
                        existingFaq.showLessButton = false;
                        existingFaq.showSpinner = false;
                    }
                    updatedItem.faqArrowClickResponse = true;
                    return updatedItem;
                }
                return item;
            });
            return updatedArray;
        }
    }

    checkEmptyObjectsInArray(arr: any) {
        arr = arr.filter(
            (obj: any) => (obj && Object.keys(obj)?.length > 0) && (obj.title || obj.content)
        );
        return arr;
    }

    formatFAQResponse(faqArray: any) {
        let searchResponse = [];
        if(faqArray && faqArray?.length > 0){
            for (let faq of faqArray) {
                let faqObject: any = {
                    question: faq.question,
                    taskRefId: faq?.taskRefId,
                    answer: (faq?.answer && faq?.answer?.length > 0) ? [] : false
                }
                if (faq.answer && faq.answer.length > 0) {
                    for (let ans of faq.answer) {
                        let object: any = {
                            taskRefId: faq.taskRefId,
                            ans: ans,
                            showMoreButton: true,
                            showLessButton: false,
                        }
                        faqObject?.answer?.push(object);
                    }
                }
                searchResponse.push(faqObject);
            }
        }
        return searchResponse;
    }

    openurlInBrowser(url: any) {
        // window.open(url, '_blank');
        if (this.aaSettings?.urlOpenBehaviour && this.aaSettings?.urlOpenBehaviour?.sendPostEvent) {
            let message = {
                method: 'AgentAssist.UrlClickedMessage',
                from: 'agent_assist',
                url: url
            };
            window.parent.postMessage(message, '*');
        } else {
            window.open(url, '_blank');
        }
    }

    extractTextFromElement(element: HTMLElement): string {
        let text = '';
        if (element) {
            const extractText = (node: Node) => {
                if (node.nodeType === Node.TEXT_NODE) {
                    text += node.textContent;
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    const childNodes = node.childNodes;
                    for (let i = 0; i < childNodes.length; i++) {
                        extractText(childNodes[i]);
                    }
                }
            };
            extractText(element);
        }
        return text.trim();
    }

    handleSendCopyButton(actionType: any, faq_or_article_obj: any, selectType: any) {
        let message: any = {};
        if (actionType == ProjConstants.SEND) {
            message = {
                method: 'send',
                name: ProjConstants.SENDMSG,
                conversationId: this.connectionDetails.conversationId,
                // payload: selectType == ProjConstants.FAQ ? (faq_or_article_obj.answer || faq_or_article_obj.ans) : faq_or_article_obj.content
                payload: faq_or_article_obj.sendContent
            };
            if (selectType === ProjConstants.ARTICLE) {
                message['title'] = faq_or_article_obj.title;
                message['contentId'] = faq_or_article_obj.contentId;
            } else {
                message['title'] = faq_or_article_obj.displayName;
                message['contentId'] = faq_or_article_obj.taskRefId
            }
        } else {
            message = {
                method: 'copy',
                name: ProjConstants.COPYMSG,
                conversationId: this.connectionDetails.conversationId,
                // payload: selectType == ProjConstants.FAQ ? (faq_or_article_obj.answer || faq_or_article_obj.ans) : faq_or_article_obj.content
                payload: faq_or_article_obj.sendContent
            };
            if (selectType === ProjConstants.ARTICLE) {
                message['title'] = faq_or_article_obj.title;
                message['contentId'] = faq_or_article_obj.contentId;
            } else {
                message['title'] = faq_or_article_obj.displayName;
                message['contentId'] = faq_or_article_obj.taskRefId
            }
        }
        message['type'] = (selectType == ProjConstants.FAQ) ? 'faq' : 'article'
        // window.parent.postMessage(message, '*');
        return (this.faqArticleSendorCopyEvent(selectType, message, faq_or_article_obj))
    }

    faqArticleSendorCopyEvent(selectType : any, message : any, faq_or_article_obj : any) {
        let data: any = {
            botId: this.connectionDetails.botId,
            conversationId: this.connectionDetails.conversationId,
            experience: this.connectionDetails?.channel,
            source: this.connectionDetails.source,
            usedType: message.method,
            type: message.type,
            name: message.name,
            payload: message.payload,
            title: message.title,
            contentId: message.contentId,
            positionId: faq_or_article_obj.positionId ? faq_or_article_obj.positionId : '',
            sessionId: (this.activeTab == Tabs.MYBOT || this.activeTab == Tabs.SEARCH) ? this.myBotTabSessionId : this.assistTabSessionId,
        };
        data = this.addSourceMsgIdToRequestParams(faq_or_article_obj, data);
        if (this.activeTab == Tabs.SEARCH) {
            data.skipMsg = this.sentSearchResponse;
            data.input = this.searchedResultData?.userInput || '';
            this.sentSearchResponse = true;
        }
        if (faq_or_article_obj.subType) {
            data.subType = faq_or_article_obj.subType;
        }
        return data;
    }
    
    addSourceMsgIdToRequestParams(data : any,requestParams : any){
        if(data.sourceMsgId){
          if(data.sourceMsgId == 'fromLibrary'){
            requestParams['fromLibrary'] = true
          }else{
            requestParams['sourceMsgId'] = data.sourceMsgId
          }
        }
        return requestParams;
    }

    addSentOrCopiedTextForFaqs(ansObj: any, ele: any, sendText: any, hostInstance : any) {
        this.sendTextAddAndEmitEvent('faqs', ansObj, ele, sendText, hostInstance);
    }

    addSentOrCopiedTextForFiles (file: any, ele: any, sendText: any, hostInstance : any) {
        this.sendTextAddAndEmitEvent('file', file, ele, sendText, hostInstance);
    }

    addSentOrCopiedTextForArticle (article: any, ele: any, sendText: any, hostInstance : any) {
        this.sendTextAddAndEmitEvent('article', article, ele, sendText, hostInstance);
    }

    addSentOrCopiedTextForSnippets (snippet: any, ele: any, sendText: any, hostInstance : any) {        
        this.sendTextAddAndEmitEvent('snippet', snippet, ele, sendText, hostInstance);
    }

    sendTextAddAndEmitEvent(type : string, suggestionObj : any, ele : any, sendText : string, hostInstance : any){
        if (!suggestionObj.send) {
            suggestionObj.send = sendText;
            let eachSuggestionSentText: any = getHTML(ActionButtonsSentText, { [type]: suggestionObj }, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, eachSuggestionSentText, { event: SDK_EVENTS.SENT_BUTTON_TEMPLATE, data: suggestionObj });
            ele.querySelector(this.classConstants.SUGGESTION_EACH_TITLE).append(eachSuggestionSentText);
        }
        if(typeof this.prefsOpacity === 'number'){
            ele.style.opacity = (this.prefsOpacity/100)
        }
        let sendTextele = ele.querySelector(this.classConstants.SEND_TEXT);
        sendTextele.textContent = sendText;
    }

    handleSendCopyButtonForFaq (actionType: any, ansObj: any, selectType: any, sourceMsgId: any, faqListHTMLEle : any, hostInstance : any) {
        // let faqTemplate = this.faqcontent.find((element : any, index : any) => index === inx);
        // let faqTemplate = faqList[inx];
        ansObj.sourceMsgId = sourceMsgId;
        ansObj.sendContent = ansObj.answer || ansObj.ans;

        let node : any = faqListHTMLEle.querySelector('p');
        ansObj.sendContent = this.prepareSendText(ansObj.sendContent, false, node);

        let copyEventData = this.handleSendCopyButton(actionType, ansObj, selectType);
        this.emitSendOrCopyEvent(copyEventData, hostInstance);
    }

    handleSendCopyButtonForSnippet (actionType: any, snippetObj: any, selectType: any, snippetListHTMLEle : any, hostInstance : any) {        
        snippetObj.sendContent = (snippetObj.sendCopyText);

        let node : any = snippetListHTMLEle.querySelector('p');
        snippetObj.sendContent = this.prepareSendText(snippetObj.sendContent, false, node);

        let copyEventData = this.handleSendCopyButton(actionType, snippetObj, selectType);
        this.emitSendOrCopyEvent(copyEventData, hostInstance);
    }

    handleSendCopyButtonArticleOrFile (actionType: any, articleObj: any, selectType: any, articleListHTMLEle : any, hostInstance : any){
        articleObj.sendContent = articleObj.content;

        let node : any = articleListHTMLEle.querySelector('p');
        articleObj.sendContent = this.prepareSendText(articleObj.sendContent, false, node);

        let copyEventData = this.handleSendCopyButton(actionType, articleObj, selectType);
        this.emitSendOrCopyEvent(copyEventData, hostInstance);
    };

    handleActionTemplateClickEventsForFAQ(eachActionTemplate : any, faq : any, ansObj : any, faqListHTMLEle : any, hostInstance : any){
        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_SEND_BTN, 'click', () => {
            this.handleSendCopyButtonForFaq(ProjConstants.SEND, ansObj, ProjConstants.FAQ, faq.sourceMsgId, faqListHTMLEle, hostInstance);
            this.addSentOrCopiedTextForFaqs(ansObj, faqListHTMLEle, 'Sent', hostInstance);
        }, eachActionTemplate);

        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_COPY_BTN, 'click', () => {
            this.handleSendCopyButtonForFaq(ProjConstants.COPY, ansObj, ProjConstants.FAQ, faq.sourceMsgId, faqListHTMLEle, hostInstance);
            this.addSentOrCopiedTextForFaqs(ansObj, faqListHTMLEle, 'Copied', hostInstance);
        }, eachActionTemplate);
    }

    emitSendOrCopyEvent(copyEventData : any, hostInstance : any){
        if(copyEventData?.usedType === 'send'){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.AGENT_SEND_MESSAGE, data: copyEventData, msg : copyEventData?.payload });
        }else{
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.AGENT_COPY_MESSAGE, data: copyEventData, msg : copyEventData?.payload });
        }
        hostInstance.socketConnection.emitEvents(EVENTS.agent_send_or_copy, copyEventData);
    }

    handleFaqExpandCloseBtnClickEvents(expandClostBtnTemplate : any, faqSuggestionBodyList : any, suggestionHeaderActionTemplate : any, faqListHTMLIndex : any, hostInstance : any){
        let expandElement = expandClostBtnTemplate.querySelector(this.classConstants.SUGGESTION_FAQ_EXPAND);
        let closeElement = expandClostBtnTemplate.querySelector(this.classConstants.SUGGESTION_FAQ_CLOSE);
        let faqAnsLenghtElement = faqListHTMLIndex?.querySelector(`${this.classConstants.SUGGESTION_EACH_HEADER} ${this.classConstants.SUGGESTION_EACH_TITLE} ${this.classConstants.SUGGESTION_FAQ_ANS_LENGTH}`);

        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_FAQ_EXPAND, 'click', () => {

            if (closeElement?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                closeElement?.classList?.remove(this.classConstants.HIDE_ELEMENT)
            }
            expandElement?.classList?.add(this.classConstants.HIDE_ELEMENT);

            faqSuggestionBodyList.forEach((ansTemplate: any, index: any) => {
                if (ansTemplate?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                    ansTemplate?.classList?.remove(this.classConstants.HIDE_ELEMENT)
                }
            });

            faqAnsLenghtElement?.classList?.add(this.classConstants.HIDE_ELEMENT);

            //hide header send copy btns
            suggestionHeaderActionTemplate?.classList?.add(this.classConstants.HIDE_ELEMENT);

            //add send copy btns for first answer
            let firstAnswerActionBtn = faqSuggestionBodyList[0]?.querySelector(this.classConstants.SUGGESTION_SENDCPY_ACTION);
            if (firstAnswerActionBtn?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                firstAnswerActionBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT)
            }

        }, expandClostBtnTemplate);

        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_FAQ_CLOSE, 'click', () => {

            if (expandElement?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                expandElement?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            }
            closeElement?.classList?.add(this.classConstants.HIDE_ELEMENT);

            faqSuggestionBodyList.forEach((ansTemplate: any, index: any) => {
                if (index != 0) {
                    ansTemplate?.classList?.add(this.classConstants.HIDE_ELEMENT);
                }
            });

            if(faqAnsLenghtElement?.classList?.contains(this.classConstants.HIDE_ELEMENT)){
                faqAnsLenghtElement?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            }

            //show header send copy btns
            if (suggestionHeaderActionTemplate?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                suggestionHeaderActionTemplate?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            }

            //remove send copy btns for first answer
            let firstAnswerActionBtn = faqSuggestionBodyList[0]?.querySelector(this.classConstants.SUGGESTION_SENDCPY_ACTION);
            firstAnswerActionBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);

        }, expandClostBtnTemplate);
    }

    handleActionTemplateClickEventsForSnippet(eachActionTemplate : any, snippet : any, snippetListHtmlEle : any, hostInstance : any){
        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_SEND_BTN, 'click', () => {
            this.handleSendCopyButtonForSnippet(ProjConstants.SEND, snippet, ProjConstants.ARTICLE, snippetListHtmlEle, hostInstance);
            this.addSentOrCopiedTextForSnippets(snippet, snippetListHtmlEle, 'Sent', hostInstance);
        }, eachActionTemplate);

        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_COPY_BTN, 'click', () => {
            this.handleSendCopyButtonForSnippet(ProjConstants.COPY, snippet, ProjConstants.ARTICLE, snippetListHtmlEle, hostInstance);
            this.addSentOrCopiedTextForSnippets(snippet, snippetListHtmlEle, 'Copied', hostInstance);
        }, eachActionTemplate);
    }

    handleActionTemplateClickEventsForArticle(eachActionTemplate : any, article : any, articleListHtmlEle : any, hostInstance : any){
        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_SEND_BTN, 'click', () => {
            this.handleSendCopyButtonArticleOrFile(ProjConstants.SEND, article, ProjConstants.ARTICLE, articleListHtmlEle, hostInstance);
            this.addSentOrCopiedTextForArticle(article, articleListHtmlEle, 'Sent', hostInstance);
            if(articleListHtmlEle?.querySelector('.aa-agentic-search-results-title')){
                hostInstance?.sendAgentMessage({
                    author: {
                        id: "authorids",
                        type: 'AGENT',
                        firstName: "first name",
                        lastName: "last name"
                    },
                    message: article?.sendContent || '',
                    type: 'USER',
                })
            }
        }, eachActionTemplate);

        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_COPY_BTN, 'click', () => {
            this.handleSendCopyButtonArticleOrFile(ProjConstants.COPY, article, ProjConstants.ARTICLE, articleListHtmlEle, hostInstance);
            this.addSentOrCopiedTextForArticle(article, articleListHtmlEle, 'Copied', hostInstance);
            if(articleListHtmlEle?.querySelector('.aa-agentic-search-results-title')){
                hostInstance?.sendAgentMessage({
                    author: {
                        id: "authorids",
                        type: 'AGENT',
                        firstName: "first name",
                        lastName: "last name"
                    },
                    message: article?.sendContent || '',
                    type: 'USER',
                })
            }
        }, eachActionTemplate);
    }

    handleActionTemplateClickEventsForFile(eachActionTemplate : any, file : any, fileListHtmlEle : any, hostInstance : any){
        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_SEND_BTN, 'click', () => {
            this.handleSendCopyButtonArticleOrFile(ProjConstants.SEND, file, ProjConstants.ARTICLE, fileListHtmlEle,hostInstance);
            this.addSentOrCopiedTextForFiles(file, fileListHtmlEle, 'Sent', hostInstance);
        }, eachActionTemplate);

        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_COPY_BTN, 'click', () => {
            this.handleSendCopyButtonArticleOrFile(ProjConstants.COPY, file, ProjConstants.ARTICLE, fileListHtmlEle, hostInstance);
            this.addSentOrCopiedTextForFiles(file, fileListHtmlEle, 'Copied', hostInstance);
        }, eachActionTemplate);
    }

    handleSuggestionLessClickEvent (actionHtml : any, suggestionElement: any, listHtml: any, hostInstance : any) {
        let moreElement = actionHtml.querySelector(this.classConstants.SUGGESTION_MORE_LINK);
        let lessElement = actionHtml.querySelector(this.classConstants.SUGGESTION_LESS_LINK);
        hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_MORE_LINK, 'click', () => {
            if (lessElement?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                lessElement?.classList?.remove(this.classConstants.HIDE_ELEMENT)
            }
            moreElement?.classList?.add(this.classConstants.HIDE_ELEMENT);
            listHtml.forEach((item: any) => {
                if (item?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                    item?.classList?.remove(this.classConstants.HIDE_ELEMENT)
                }
            });
        }, suggestionElement)

    }

    handleSuggestionMoreClickEvent (actionHtml : any, suggestionElement: any, listHtml: any, hostInstance : any) {
        let moreElement = actionHtml.querySelector(this.classConstants.SUGGESTION_MORE_LINK);
        let lessElement = actionHtml.querySelector(this.classConstants.SUGGESTION_LESS_LINK);
        hostInstance?.eventManager?.addEventListener(this.classConstants.SUGGESTION_LESS_LINK, 'click', () => {
            if (moreElement?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                moreElement?.classList?.remove(this.classConstants.HIDE_ELEMENT)
            }
            lessElement?.classList?.add(this.classConstants.HIDE_ELEMENT);
            listHtml.forEach((item: any, inx: any) => {
                if (inx >= 2 && item) {
                    item?.classList?.add(this.classConstants.HIDE_ELEMENT);
                }
            });
        }, suggestionElement);

    }

    setFaqIndividualLoader (inx : any, hide = false, id : string, hostInstance : any) {
        let faqSuggestionEle : any = hostInstance?.chatEle?.querySelector(`#${id}`); 
        let faqListHTML = faqSuggestionEle?.querySelectorAll(this.classConstants.SUGGESTION_EACH);
        let faqLoaderEle = faqListHTML[inx]?.querySelector(`${this.classConstants.SUGGESTION_EACH_HEADER} ${this.classConstants.SUGGESTION_EACH_TITLE} ${this.classConstants.SUGGESTION_FAQ_ANS_LOADER}`);
        
        if(hide && faqLoaderEle){
            faqLoaderEle?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }else if(faqLoaderEle){
            if (faqLoaderEle?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                faqLoaderEle?.classList?.remove(this.classConstants.HIDE_ELEMENT)
            }
            setTimeout(() => {
                faqLoaderEle?.classList?.add(this.classConstants.HIDE_ELEMENT);
            }, 10000);
        }
    }

    addOrHideFAQArrows(faqUpArrowTemplate : any, faqDownArrowTemplate : any,  type : string){
        if(type === 'up'){
            if(faqDownArrowTemplate?.classList?.contains(this.classConstants.HIDE_ELEMENT)){
                faqDownArrowTemplate?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            }
            faqUpArrowTemplate?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }else{
            if(faqUpArrowTemplate?.classList?.contains(this.classConstants.HIDE_ELEMENT)){
                faqUpArrowTemplate?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            }
            faqDownArrowTemplate?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }
    }

    toggleArrows(index : number, faqId : string, hostInstance : any){
        let faqSuggestionEle : any = hostInstance?.chatEle?.querySelector(`#${faqId}`); 
        let faqListHTML = faqSuggestionEle?.querySelectorAll(this.classConstants.SUGGESTION_EACH);
        let suggestionHeaderTemplate = faqListHTML[index]?.querySelector(this.classConstants.SUGGESTION_EACH_HEADER);

        let faqUpArrowTemplate = suggestionHeaderTemplate?.querySelector(this.classConstants.SUGGESTION_FAQ_UP_ARROW);
        let faqDownArrowTemplate = suggestionHeaderTemplate?.querySelector(this.classConstants.SUGGESTION_FAQ_DOWN_ARROW);
        this.addOrHideFAQArrows(faqUpArrowTemplate, faqDownArrowTemplate, 'down');
    }

    openLinksInBrowser(url: any) {
        this.openurlInBrowser(url);
    };

    openurlInBrowserForSnippet(url: any, snippet: any, hostInstance : any) {
        this.openurlInBrowser(url);
        this.handleUrlClickEvent(url, snippet, hostInstance);
    }
    
    handleUrlClickEvent (url: any, snippet: any, hostInstance : any) {
        let socketRequestParams: any = this.commonRequestParamsForActivity(snippet);
        socketRequestParams.eventType = "url_clicked";
        socketRequestParams.url = url;
        hostInstance.socketConnection.emitEvents(EVENTS.agent_activity_request, socketRequestParams);
    }

    commonRequestParamsForActivity (snippet: any) {
        const { botId, conversationId, channel } = this.connectionDetails;
        let socketRequestParams = {
            botId: botId,
            conversationId: conversationId,
            event: "clicked",
            sourceMsgId: snippet.sourceMsgId,
            dataSource: "snippet",
            positionId: snippet.positionId,
            participant : this?.internalTransferData?.participant || {}
        }
        return socketRequestParams;
    }

    emitSearchRequestForAssistSuggestions (value : any, isSearch : any, faq : any, hostInstance : any) {
        let connectionDetails: any = Object.assign({}, this.connectionDetails);
        connectionDetails.value = value;
        connectionDetails.isSearch = isSearch;
        // connectionDetails.positionId = searchObj?.positionId;
        if (connectionDetails.interactiveLanguage && typeof connectionDetails.interactiveLanguage == 'string' && connectionDetails.interactiveLanguage != "''") {
          connectionDetails['language'] = connectionDetails.interactiveLanguage; // Return the default value for null, undefined, or "''"
        }
        if(faq.sourceMsgId){
          connectionDetails['sourceMsgId'] = faq.sourceMsgId;
        }

        let agent_assist_request_params = hostInstance.prepareAgentAssistRequestParams(connectionDetails);

        if(faq.ambiguityToken){
            agent_assist_request_params.uiunqref = faq.ambiguityToken;
        }
        hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_request, agent_assist_request_params);
    }

    emitSearchRequestForSearch (searchTextObj : any, isSearch: boolean, faq: any = {}, hostInstance : any) {
        let searchTextValue = searchTextObj?.value;
        const connectionDetails = { ...hostInstance?.socketConnection?.configOptions?.connectionDetails, value : searchTextValue, isSearch };
        if (connectionDetails.interactiveLanguage && typeof connectionDetails.interactiveLanguage === 'string' && connectionDetails.interactiveLanguage !== "''") {
            connectionDetails.language = connectionDetails.interactiveLanguage;
        }
        if (faq && faq.sourceMsgId) {
            connectionDetails.sourceMsgId = faq.sourceMsgId;
        }
        const agentAssistAgentRequestParams = hostInstance.prepareAgentAssistAgentRequestParams(connectionDetails);
        if(isSearch){
            agentAssistAgentRequestParams.startTime = searchTextObj?.stTime;
            agentAssistAgentRequestParams.endTime = searchTextObj?.edTime;
        }
        if(faq.ambiguityToken){
            agentAssistAgentRequestParams.uiunqref = faq.ambiguityToken;
        }
        agentAssistAgentRequestParams.participant = this.internalTransferData?.participant || {};
        hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_agent_request, agentAssistAgentRequestParams);
    };

    handleFaqAmbiguityDescElement(faqId : string, ambiguityToken : any, faqs : any, hostInstance : any){        
        let faqSuggestionEle : any = hostInstance?.chatEle?.querySelector(`#${faqId}`); 
        let faqListHTML = faqSuggestionEle?.querySelectorAll(this.classConstants.SUGGESTION_EACH);
        let faqinx  = ambiguityToken?.index;
        let descEle : any;
        let faqwithAns = faqs[faqinx];
        this.setFaqIndividualLoader(faqinx, true, faqId, hostInstance);
        if(faqwithAns && faqwithAns?.answer?.length > 0 && faqListHTML[faqinx]){
            descEle = getHTML(FaqAnswerPlacement, { faq : faqwithAns, hostInstance }, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, descEle, { event: SDK_EVENTS.FAQ_ANSWER_AFTER_TOGGLE, data: faqs });
            if(descEle){
                const feedbackWrapper = faqListHTML[faqinx]?.querySelector?.(`${this.classConstants.FEEDBACK_WRAPPER}${faqwithAns?.positionId}`);
                if(feedbackWrapper){
                    faqListHTML[faqinx].insertBefore(descEle, feedbackWrapper);
                }else{
                    faqListHTML[faqinx].append(descEle);
                }
                this.handleSeeMoreButtonsForFaq(faqSuggestionEle, ClassMapConstanst.DESC_TEXT_SUGGESTION, ClassMapConstanst.MORE_BTN_CONTAINER, hostInstance, faqinx);
            }
        }
        
        let suggestionHeaderTemplate = faqListHTML[faqinx]?.querySelector(this.classConstants.SUGGESTION_EACH_HEADER);
        this.addOrHideFAQActionExpandCloseElements(faqwithAns, suggestionHeaderTemplate, faqListHTML, faqinx, hostInstance);
    }

    handleFaqToggle (faq : any, index : any , type : string, faqListHTML : any, hostInstance : any, isAssistSuggestion : boolean, props : any) {
        faq.toggle = !faq.toggle;
        faq.seeMoreWrapper = false;
        let faqSuggestionBodyList = faqListHTML[index]?.querySelectorAll(this.classConstants.SUGGESTION_EACH_BODY);
        if(type == 'down' && !faq.answer){
            if(isAssistSuggestion){
                this.checkAnswerAndToggleForAssist(faq, index, hostInstance, props);
            }else{
                this.checkAnswerAndToggleForSearch(faq, index, hostInstance);
            }
        }else if (type == 'down' && faq.answer){
            faqSuggestionBodyList.forEach((ansTemplate: any, index: any) => {
                if (ansTemplate?.classList?.contains(this.classConstants.HIDE_ELEMENT)) {
                    ansTemplate?.classList?.remove(this.classConstants.HIDE_ELEMENT)
                }
            });
        }else if(type == 'up'){
            faqSuggestionBodyList.forEach((ansTemplate: any, index: any) => {
                ansTemplate?.classList?.add(this.classConstants.HIDE_ELEMENT);
            });
        }
    }

    checkAnswerAndToggleForAssist (faq: any, index : number, hostInstance : any, props : any){
        if (!faq.answer && faq.toggle) {
            faq.ambiguityToken = btoa(JSON.stringify({ question: faq.question, index : index, assistSuggestion: props.suggestionIndex }));
            this.emitSearchRequestForAssistSuggestions(faq.displayName, false, faq, hostInstance);
            let faqId = this.idConstants.ASSIST_FAQ_SUGGESTION  + props.suggestionIndex;
            this.setFaqIndividualLoader(index, false, faqId, hostInstance);
        }
    };

    checkAnswerAndToggleForSearch(faq: any, index : number, hostInstance : any){
        if (!faq.answer && faq.toggle) {
            faq.ambiguityToken = btoa(JSON.stringify({ question: faq.question, index : index }));
            this.emitSearchRequestForSearch({value : faq.displayName}, false, faq, hostInstance);
            this.setFaqIndividualLoader(index, false, this.idConstants.SEARCH_FAQ_SUGGESTION, hostInstance);
        }
    }

    renderEachFaqInSuggestionList(searchResponse : any, faqListHTML : any, hostInstance : any, isAssistSuggestion : boolean, props : any){
        searchResponse?.faqs?.forEach((faq: any, index : number) => {

            let suggestionHeaderTemplate = faqListHTML[index]?.querySelector(this.classConstants.SUGGESTION_EACH_HEADER);

            let faqUpArrowTemplate = suggestionHeaderTemplate?.querySelector(this.classConstants.SUGGESTION_FAQ_UP_ARROW);
            let faqDownArrowTemplate = suggestionHeaderTemplate?.querySelector(this.classConstants.SUGGESTION_FAQ_DOWN_ARROW);            

            hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_FAQ_UP_ARROW, 'click', () => {

                this.addOrHideFAQArrows(faqUpArrowTemplate, faqDownArrowTemplate, 'up');
                this.handleFaqToggle(faq, index, 'up', faqListHTML, hostInstance, isAssistSuggestion, props);
                
            }, suggestionHeaderTemplate);

            hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_FAQ_DOWN_ARROW, 'click', () => {

                this.addOrHideFAQArrows(faqUpArrowTemplate, faqDownArrowTemplate, 'down');
                this.handleFaqToggle(faq, index, 'down', faqListHTML, hostInstance, isAssistSuggestion, props)
                
            }, suggestionHeaderTemplate);

            if (faq.answer && faq?.answer?.length > 0 && !this.hideActionButtons) {
            
                this.addOrHideFAQActionExpandCloseElements(faq, suggestionHeaderTemplate, faqListHTML, index, hostInstance)
                
            }

        });
    }

    renderEachSnippetInSuggestionList(searchResponse : any, snippetListHtml : any, hostInstance : any){
        searchResponse?.snippets?.forEach((snippet: any, index : number) => {
            if(snippet.contentArray.length > 0){
                let eachActionTemplate: any = getHTML(handleSendCopyButtons, { snippet: snippet, hostInstance: hostInstance, rootServiceInstance : hostInstance.rootService }, hostInstance);
                if (eachActionTemplate && eachActionTemplate?.nodeName != '#text') {
                    snippetListHtml[index]?.querySelector(this.classConstants.SUGGESTION_EACH_HEADER).append(eachActionTemplate);
                    this.handleActionTemplateClickEventsForSnippet(eachActionTemplate, snippet, snippetListHtml[index], hostInstance);  
                }
            }

            let sourceListHtml = snippetListHtml[index].querySelectorAll(this.classConstants.SUGGESTION_SNIPPET_SOURCE_TAG);                

            snippet.sources?.forEach((source : any, inx : any) => {
                hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_SNIPPET_LINK, 'click', () => {
                    this.openurlInBrowserForSnippet(source.url, snippet, hostInstance)
                }, sourceListHtml[inx]);
            });
        });
    }

    handleSendCopyForAgenticSearchResults(agenticSearchResultsElement : any, response:any, hostInstance : any){
        let eachActionTemplate: any = getHTML(handleSendCopyButtons, { agenticSearchResultsElement: agenticSearchResultsElement, hostInstance: hostInstance, rootServiceInstance : hostInstance.rootService }, hostInstance);
        if (eachActionTemplate && eachActionTemplate?.nodeName != '#text') {
            agenticSearchResultsElement?.querySelector(this.classConstants.SUGGESTION_EACH_HEADER).append(eachActionTemplate);
            this.handleActionTemplateClickEventsForArticle(eachActionTemplate, response?.response, agenticSearchResultsElement , hostInstance);
        }
    }

    renderEachArticleInSuggestionList(searchResponse : any, articlesListHTML : any, hostInstance : any){
        searchResponse?.articles?.forEach((article: any, index : number) => {

            if(article?.content && !article?.internalFlag){
                let eachActionTemplate: any = getHTML(handleSendCopyButtons, { article: article, hostInstance: hostInstance, rootServiceInstance : hostInstance.rootService }, hostInstance);
                if (eachActionTemplate && eachActionTemplate?.nodeName != '#text') {
                    articlesListHTML[index]?.querySelector(this.classConstants.SUGGESTION_EACH_HEADER).append(eachActionTemplate);
                    this.handleActionTemplateClickEventsForArticle(eachActionTemplate, article, articlesListHTML[index], hostInstance);  
                }
            }
            hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_ARTICLE_LINK, 'click', () => {
                this.openLinksInBrowser(article.link)
            }, articlesListHTML[index]);

        });
    }

    renderEachFileInSuggestionList(searchResponse : any, filesListHtml : any, hostInstance : any){
        searchResponse?.files?.forEach((file: any, index : number) => {
            if(file?.content && !file?.internalFlag){
                let eachActionTemplate: any = getHTML(handleSendCopyButtons, { file: file, hostInstance: hostInstance, rootServiceInstance : hostInstance.rootService }, hostInstance);
                if (eachActionTemplate && eachActionTemplate?.nodeName != '#text') {
                    filesListHtml[index]?.querySelector(this.classConstants.SUGGESTION_EACH_HEADER).append(eachActionTemplate);
                    this.handleActionTemplateClickEventsForFile(eachActionTemplate, file, filesListHtml[index], hostInstance);  
                }
            }
            hostInstance.eventManager?.addEventListener(this.classConstants.SUGGESTION_FILE_LINK, 'click', () => {
                this.openLinksInBrowser(file.link)
            }, filesListHtml[index]);
        });

    }

    // search
    handleSearchText(searchText : any, hostInstance : any){
        if (searchText.isEntered) {
            this.emitSearchRequestForSearch (searchText, true,{}, hostInstance);
        }
        let inputBlock = hostInstance?.chatEle?.querySelector(this.classConstants.SEARCH_INPUT_BLOCK);
        let inputEle = hostInstance?.chatEle?.querySelector(`#${this.idConstants.SEARCH_INPUT}`);
        if (inputBlock) {
            let inputCloseIcon = inputBlock?.querySelector(this.classConstants.SEARCH_INPUT_CLOSE);
            if (searchText.value) {
                inputCloseIcon.classList.remove(this.classConstants.HIDE_ELEMENT);
            } else {
                inputCloseIcon.classList.add(this.classConstants.HIDE_ELEMENT);
            }
            inputEle.value = searchText.value;
        }
    }

    addOrHideFAQActionExpandCloseElements(faq : any, suggestionHeaderTemplate : any, faqListHTML : any, index : any, hostInstance : any){
        let eachActionTemplate: any = getHTML(handleSendCopyButtons, { ansObj: faq.answer[0], hostInstance: hostInstance, addHideClass: false, rootServiceInstance : hostInstance.rootService }, hostInstance);

        if (suggestionHeaderTemplate && eachActionTemplate && eachActionTemplate?.nodeName != '#text') {

            suggestionHeaderTemplate.append(eachActionTemplate);

            this.handleActionTemplateClickEventsForFAQ(eachActionTemplate, faq, faq.answer[0], faqListHTML[index], hostInstance);  
        }                    
        
        if (faq.answer?.length > 1) {

            let faqSuggestionBodyList = faqListHTML[index]?.querySelectorAll(this.classConstants.SUGGESTION_EACH_BODY);

            faq.answer?.forEach((ansObj: any, inx: any) => {

                let eachAnsActionTemplate: any = getHTML(handleSendCopyButtons, { ansObj: ansObj, hostInstance: hostInstance, addHideClass: (inx == 0 ? true : false), rootServiceInstance : hostInstance.rootService }, hostInstance);

                if (eachAnsActionTemplate && eachAnsActionTemplate?.nodeName != '#text') {


                    if (faqSuggestionBodyList && faqSuggestionBodyList?.length > 0) {

                        faqSuggestionBodyList[inx].prepend(eachAnsActionTemplate);

                        this.handleActionTemplateClickEventsForFAQ(eachAnsActionTemplate, faq, ansObj, faqListHTML[index], hostInstance);  
                    }

                }
            });

            let expandClostBtnTemplate: any = getHTML(FaqExpandCloseBtn, {}, hostInstance);

            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, expandClostBtnTemplate, {
                event: SDK_EVENTS.FAQ_EXPAND_CLOSE_TEMPLATE,
                data : {}
            });
            
            faqListHTML[index]?.append(expandClostBtnTemplate);

            let suggestionHeaderActionTemplate = faqListHTML[index]?.querySelector(`${this.classConstants.SUGGESTION_EACH_HEADER} ${this.classConstants.SUGGESTION_SENDCPY_ACTION}`);

            this.handleFaqExpandCloseBtnClickEvents(expandClostBtnTemplate, faqSuggestionBodyList, suggestionHeaderActionTemplate, faqListHTML[index], hostInstance)
           
        }
    }

    handleSeeMoreButtonsForSearchAssist(suggestionElement : any, descClassName : any, moreContainer : any, hostInstance : any){
        let suggestionBodyFaq : any = suggestionElement?.querySelectorAll('.suggestion-item-card .suggestion-body-faq');
        suggestionBodyFaq?.forEach((bodyele : any, i : number) => {
            let desc = bodyele.querySelector(descClassName);
            if(desc){
                let overlimitContainer = bodyele?.querySelector(moreContainer)
                let moreButton = overlimitContainer?.querySelector(this.classConstants.MORE_BUTTON);
                const scrollDimensions = safeScrollDimensions(desc);
                const clientDimensions = safeDimensions(desc);
                const isOverLimit = scrollDimensions.scrollHeight > clientDimensions.height;
                if (isOverLimit) {
                    overlimitContainer.classList.remove(this.classConstants.HIDE_ELEMENT);
                    hostInstance.eventManager?.addEventListener(this.classConstants.MORE_BUTTON, 'click', (e : any) => {
                        desc.classList.toggle(this.classConstants.SUGGESTION_EXPANDED);
                        moreButton.textContent = desc.classList.contains(this.classConstants.SUGGESTION_EXPANDED) ? ProjConstants.READ_LESS : ProjConstants.READ_MORE;
                    }, overlimitContainer);
                }
            }
        });
    }

    handleSeeMoreButtonsForFaq(suggestionElement : any, descClassName : any, moreContainer : any, hostInstance : any, faqinx = -1){        
        let suggestionEachFaq: any = suggestionElement?.querySelectorAll(this.classConstants.SUGGESTION_EACH);
        suggestionEachFaq?.forEach((eachFaq : any, i : number) => {
            if(faqinx == -1 || faqinx === i){
                eachFaq.querySelectorAll(this.classConstants.SUGGESTION_EACH_BODY)?.forEach((bodyele : any, ii : number) => {
                    let desc = bodyele.querySelector(descClassName);
                    if(desc){
                        let overlimitContainer = bodyele?.querySelector(moreContainer)
                        let moreButton = overlimitContainer?.querySelector(this.classConstants.MORE_BUTTON);
                        const scrollDimensions = safeScrollDimensions(desc);
                        const clientDimensions = safeDimensions(desc);
                        const isOverLimit = scrollDimensions.scrollHeight > clientDimensions.height;                    
                        if (isOverLimit) {
                            overlimitContainer.classList.remove(this.classConstants.HIDE_ELEMENT);
                            hostInstance.eventManager?.addEventListener(this.classConstants.MORE_BUTTON, 'click', (e : any) => {
                                desc.classList.toggle(this.classConstants.SUGGESTION_EXPANDED);
                                moreButton.textContent = desc.classList.contains(this.classConstants.SUGGESTION_EXPANDED) ? ProjConstants.READ_LESS : ProjConstants.READ_MORE;
                            }, overlimitContainer);
                        }
                        if(ii > 0){
                            bodyele.classList.add(this.classConstants.HIDE_ELEMENT);
                        }
                    }
                });
            }
        });
    }


 // playbook related logic.
  prepareChecklistPayload(event : any, checkListData : any, checklistObj : any, step = false, stageId = ''){

    let payload : any = {
        "event": event,
        "conversationId": this.connectionDetails.conversationId,
        "ccVersion": checkListData?.ccVersion,
        "accountId": checkListData?.accountId,
        "botId": (this.connectionDetails?.fromSAT) ?  this.connectionDetails?.instanceBotId : this.connectionDetails?.botId,
        "agentInfo": {
            "agentId": "", // mendatory field
            //any other fields
        },
        "timestamp": 0,
        "context": {}
    };

    if(checkListData?.isSuggestedCL){
        payload.isSuggestedCL = true;
    }

    if(step){
       payload.checklistStep = checklistObj
    }else{
       payload.checklist = checklistObj
    }

    if(stageId){
       payload.checklist.stageId = stageId;
    }



    let payloadStructure : any = {
      "botId": (this.connectionDetails?.fromSAT) ?  this.connectionDetails?.instanceBotId : this.connectionDetails?.botId,
      "payload": payload
    }

    return payloadStructure
  }

  sendAndCopyForPlaybook(eventName : string, payload : any, eachPlaybookStep : any, hostInstance : any){
    let message : any = {
      method: (eventName == ProjConstants.SEND_METHOD) ? ProjConstants.SEND_METHOD : ProjConstants.COPY_METHOD,
      name: (eventName == ProjConstants.SEND_METHOD) ? ProjConstants.SENDMSG : ProjConstants.COPYMSG,
      conversationId : this.connectionDetails.conversationId,
      payload,
    };

    if (eventName == ProjConstants.SEND_METHOD) {
      hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, eachPlaybookStep, { event: SDK_EVENTS.PLAYBOOK_SEND_EVENT,  data : {message}});
    } else if (eventName == ProjConstants.COPY_METHOD) {
      hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, eachPlaybookStep, { event: SDK_EVENTS.PLAYBOOK_COPY_EVENT,  data : {message}});
    }
  }

    sendCheckListCompleteEvent(prevCheckListsData: any, id: any, hostInstance: any) {
        let checklistParams: any = this.prepareChecklistPayload('checklist_closed', prevCheckListsData, { "id": id });
        hostInstance.socketConnection.emitEvents(EVENTS.checklist_closed, checklistParams);
    }

    checkAllStagesCompleted(prevCheckListsData: any, id: any, hostInstance : any) {
        let checklists = prevCheckListsData.checklists;
        let completed = false;
        let i = (checklists || []).findIndex((item: any) => item._id === id);
        if (checklists[i]?.type !== 'primary') {
            completed = (checklists[i].stages[0]?.steps || [])
                .every((item: any) => item.complete);
            if (completed) {
                checklists[i].completed = true;
                this.sendCheckListCompleteEvent(prevCheckListsData, id, hostInstance);
            }
        } else {
            let open = (checklists[i].stages[0]?.steps || [])
                .every((item: any) => item.complete);
            if (open) {
            }
            let close = (checklists[i].stages[1]?.steps || [])
                .every((item: any) => item.complete);

            if(close){
                hostInstance?.chatEle?.querySelector(ClassMapConstanst.PROCEEDTOCLOSE_BTN)?.classList?.add(ClassMapConstanst.CHECKLIST_DISABLE_MSG)
            }
            //   if (close) {
            //     if (!this.openAck) {
            //       this.isCloseCompleted = true;
            //       setTimeout(() => {
            //         this.isCloseCompleted = false;
            //         this.openAck = true;
            //       }, 3000);
            //     }
            //   }
            if (open && close) {
                checklists[i].completed = true;
                completed = true;
            }
            if (completed) {
                this.sendCheckListCompleteEvent(prevCheckListsData, id, hostInstance);
            }
        }
    }

    updateStepTemplate(prevCheckListsData: any, hostInstance : any){        
        prevCheckListsData.checklists[this.selCLInx]?.stages?.map((stage: any, stInx: number) => {
            stage?.steps?.map((step: any, stepInx: number) => {
                let stepEle = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_EACH_STEP}${stInx}-${stepInx}`);
                let stepCloseEle = stepEle?.querySelector(`${ClassMapConstanst.CHECKLIST_STEP_COMPLETE_BTN}${stInx}-${stepInx}`);
                if (stepEle) {
                    if (step.ongoing === false) {
                        stepEle?.classList?.remove(ClassMapConstanst.CHECKLIST_STEP_ONGOING);
                        stepEle?.querySelector(`${ClassMapConstanst.CHECKLIST_HEADER_STEP}`)?.classList?.add(ClassMapConstanst.CHECKLIST_DISABLE_MSG);
                        stepCloseEle?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
                        stepEle?.querySelector(`${ClassMapConstanst.CHECKLIST_STEP_SEND_BLOCK}`)?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
                    }
                    if (step.complete === true) {
                        stepEle?.querySelector(`${ClassMapConstanst.CHECKLIST_HEADER_STEP_NAME}`)?.classList?.add(ClassMapConstanst.CHECKLIST_STRIKE);
                    }
                    if (step.ongoing === true) {
                        stepEle?.classList?.add(ClassMapConstanst.CHECKLIST_STEP_ONGOING);
                        stepEle?.querySelector(`${ClassMapConstanst.CHECKLIST_HEADER_STEP}`)?.classList?.remove(ClassMapConstanst.CHECKLIST_DISABLE_MSG);
                        stepCloseEle?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
                        stepEle?.querySelector(`${ClassMapConstanst.CHECKLIST_STEP_SEND_BLOCK}`)?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
                    }
                }
            });
        });
    }

    selectNextStep(prevCheckListsData: any, clIndex: number, stInx: number, hostInstance : any) {
        let allStepsComplete = true;
        let index = 0;
        this.closeAllStepsInStage(prevCheckListsData, clIndex, stInx);

        for (let step of prevCheckListsData.checklists[clIndex]?.stages[stInx]?.steps) {
            if (!step.complete) {
                step.ongoing = true;
                allStepsComplete = false;
                this.selSpInx = index;
                this.scrollView(step._id, hostInstance);
                break;
            }
            index++;
        }
        return allStepsComplete;
    }

    closeAllStepsInStage(prevCheckListsData: any, clIndex: number, stInx: number) {
        prevCheckListsData.checklists[clIndex]?.stages.forEach((stage: any) => {
            stage?.steps.forEach((step: any) => {
                step.ongoing = false;
            });
        });
    }

    selectStepForRandom (stInx: number, step: any, stepInx: number, hostInstance : any){        
        this.selStInx = stInx;
        this.selSpInx = stepInx;
        step.ongoing = true;
        let stepId = step._id;
        this.scrollView(stepId, hostInstance);
    }

    selectStage(prevCheckListsData: any, clIndex: number, stInx: number, hostInstance : any) {
        this.selStInx = stInx;
        this.selectNextStep(prevCheckListsData, clIndex, stInx, hostInstance);
        this.updateStepTemplate(prevCheckListsData, hostInstance);
    }

    scrollView (stepId: any, hostInstance : any) {
        if (hostInstance.chatEle.querySelector(`#${stepId}`)) {
            hostInstance.chatEle.querySelector(`#${stepId}`).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
    }
  
    // update proceed to close button based on primary checklists
    showProceedToCloseBtn (hostInstance : any) {
        let proceedToClostBtn = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.PROCEEDTOCLOSE_BTN}`);
        proceedToClostBtn.classList.remove(ClassMapConstanst.HIDE_ELEMENT);
    }

    clickStep(prevCheckListsData: any, stInx: number, step: any, stepInx: number, hostInstance : any) {
        let selCLInx = this.selCLInx;
        let selStInx = this.selStInx;
        let selSpInx = this.selSpInx;

        let checklists = prevCheckListsData.checklists;
        let cl = checklists[selCLInx];

        if (step?.complete || step?.ongoing) {
            return;
        } else if (cl?.order === "random") {
            checklists[selCLInx].stages[selStInx].steps[selSpInx].ongoing = false;
            this.selectStepForRandom(stInx, step, stepInx, hostInstance);
            this.updateStepTemplate(prevCheckListsData, hostInstance);
        } else {
            return;
        }
    }

    getNumberstepCompInStage (prevCheckListsData : any){
        let stepNum = 0;
        for(let step of prevCheckListsData.checklists[this.selCLInx]?.stages[this.selStInx]?.steps){
          if(step.complete){
            stepNum += 1;
          }
        }
        return stepNum;
    }

    handleStageCheck(parentEle : any, stInx : number, stageList : any, hostInstance : any) {
        let selectedStageSpan = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.SELECTED_STAGE}`);
        if(selectedStageSpan){
            selectedStageSpan.innerText = stageList[stInx]?.name;
        }
        stageList?.map((stage: any, inx: number) => {
            let ele = parentEle?.querySelector(`${ClassMapConstanst.CHECKLIST_SELECTED_STAGE_CHECK}${inx}`);
            inx === stInx ? ele?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT) : ele?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
        });
    }

    selectNextStage (prevCheckListsData: any, clIndex: number, stInx: number, hostInstance : any) {
        let allStepsCompleteInStage = this.selectNextStep(prevCheckListsData, clIndex, stInx, hostInstance);
        if (allStepsCompleteInStage && prevCheckListsData.checklists[clIndex]?.stages[stInx + 1]) {
            if (prevCheckListsData.checklists[clIndex]?.stages[stInx + 1].name != 'Close' || this.isProceedToClose) {
                let stageDropdown = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.STAGE_DROPDOWN}`);
                this.handleStageCheck(stageDropdown, stInx+1, prevCheckListsData.checklists[clIndex]?.stages, hostInstance);
                this.selectStage(prevCheckListsData, clIndex, stInx + 1, hostInstance);
            }
        }
        this.updateStepTemplate(prevCheckListsData, hostInstance);
    }

    confirmationBtnForPlaybook(btn : any, eachPlaybookStep: any, hostInstance : any) {
        let eventName = btn.title === 'yes' ? SDK_EVENTS.PLAYBOOK_CONFIRMATION_YES : SDK_EVENTS.PLAYBOOK_CONFIRMATION_NO;
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, eachPlaybookStep, { event: eventName,  data : {btn}});
    }

    hideDropdownTemplate(cls : any, hostInstace : any){
        let sharedowns = hostInstace?.chatEle?.getElementsByClassName(cls);        
        let i;
        for (i = 0; i < sharedowns.length; i++) {
            let openSharedown = sharedowns[i];
            if (openSharedown.classList.contains('show')) {
                openSharedown.classList.remove('show');
            }
        }
    }

    prepareFeedbackForSummary(feedbackData : any){
        let renderResponse: any = {
            type: 'summary',
            positionId: feedbackData?.positionId,
            summaryId: feedbackData?.summaryId,
            traceId: feedbackData?.traceId,
            submitForm: feedbackData?.feedback ? true : false,
            feedback: feedbackData?.feedback ? feedbackData.feedback : '',
            feedbackDetails: feedbackData?.feedbackDetails?.length ? feedbackData.feedbackDetails : [],
            comment: feedbackData?.comment ? feedbackData?.comment : '',
            sourceMsgId: '',
            query: '',
            suggestionType: 'summary',
            interactionType : 'assist', 
        }
        return renderResponse;
    }

    prepareFeedbackForSuggestions(suggestionType: any, suggestion: any, feedbackData: any = {}) {
        let renderResponse: any = {
            type: RenderResponseType.FEEDBACK,
            positionId: suggestion.positionId,
            submitForm: feedbackData?.feedback ? true : false,
            feedback: feedbackData?.feedback ? feedbackData.feedback : '',
            feedbackDetails: feedbackData?.feedbackDetails?.length ? feedbackData.feedbackDetails : [],
            comment: feedbackData?.comment ? feedbackData?.comment : '',
            sourceMsgId: suggestion.sourceMsgId || '',
            query: suggestion.userInput,
            suggestionType: suggestionType,
            subType: suggestion.subType || ''
        }

        if (suggestionType == 'answer') {
            renderResponse.isFromGeneratedSummary = suggestion.isFromGeneratedSummary;
            renderResponse.answerType = suggestion.templateType;
            renderResponse.title = suggestion.title;
            renderResponse.answer = suggestion.sendCopyText || '';
            renderResponse.interactionType = suggestion.intType;
            renderResponse.sources = suggestion.sources;
            if (suggestion.internalInfo?.length > 0) {
                renderResponse.answer += suggestion.internalInfo.join(' ');
            }
        } else if (suggestionType == 'article' || suggestionType == 'file') {
            renderResponse.title = suggestion.title;
            renderResponse.answer = suggestion.content || '';
            renderResponse.interactionType = suggestion.intType;
        } else if (suggestionType == 'faqs') {
            let answer = '';
            if (Array.isArray(suggestion?.answer)) {
                suggestion?.answer?.forEach((element: any) => {
                    answer += element.ans;
                });
            }
            renderResponse.title = suggestion.question;
            renderResponse.answer = answer;
        }
        return renderResponse
    }

    prepareFeedbackDataForDialog(automation: any, feedbackData: any = {}, isHistory: boolean = false) {
        let renderResponse: any = {
            type: RenderResponseType.FEEDBACK,
            uuid: automation.uuid,
            dialogName: automation.dialogName,
            positionId: automation.dialogId,
            submitForm: feedbackData?.feedback ? true : false,
            feedback: feedbackData?.feedback ? feedbackData.feedback : '',
            feedbackDetails: feedbackData?.feedbackDetails?.length ? feedbackData.feedbackDetails : [],
            comment: feedbackData?.comment ? feedbackData?.comment : '',
            sourceMsgId: automation.sourceMsgId || '',
            isHistory: isHistory
        }
        return renderResponse;
    }

    //Assist and mybot tab starts

    makeOverrideEvent (hostInstance : any, flag : boolean) {
        if (this.OverRideMode && this.proactiveMode && !this.manualAssistOverrideMode) {
          hostInstance.handleOverrideMode(flag, null);
        }
    }

    getTypeOfResponse (data: any){   
       
        let responseType = '';
        if (!this.isAutomationOnGoing && data.suggestions && Object.keys(data.suggestions)?.length > 0) {
            responseType = RenderResponseType.SUGGESTIONS;
        } else if(this.isAutomationOnGoing && data.ambiguityList && Object.keys(data.ambiguityList)?.length > 0){
            responseType = RenderResponseType.SUGGESTIONS;
        } else if (!data.sendMenuRequest) {
            if (this.isAutomationOnGoing && data.buttons?.length > 0 && (this.currentAutomationId && !data.positionId || (data.positionId == this.currentAutomationId))) {
                responseType = RenderResponseType.AUTOMATION_NODE;
            } else if (!this.isAutomationOnGoing && data.buttons?.length > 0) {
                responseType = RenderResponseType.SMALLTALK;
            }
            else if(this.isAutomationOnGoing && data.suggestions && Object.keys(data.suggestions)?.length > 0){
                responseType = RenderResponseType.SUGGESTIONS;
            }
            else{
                responseType = RenderResponseType.AUTOMATION_NODE;
            }
        } else if (data?.buttons?.length > 0) {
            responseType = RenderResponseType.WELCOME_MSG;
        }
        return responseType;
    }

    getMybotTypeOfResponse (data : any){
        let responseType = '';
        if (this.isMyBotAutomationOnGoing && data.buttons?.length > 0 && (this.currentMybotAutomationId && !data.positionId || (data.positionId == this.currentMybotAutomationId))) {
            responseType = RenderResponseType.AUTOMATION_NODE;
        } else if (!this.isAutomationOnGoing && data.buttons?.length > 0) {
            responseType = RenderResponseType.SMALLTALK;
        }
        return responseType;
    }

    getCustomTabTypeOfResponse (data : any){
        let responseType = '';
        if(this.isCustomTabAutomationOnGoing && data.buttons?.length > 0 && (this.currentCustomTabAutomationId && !data.positionId || (data.positionId == this.currentCustomTabAutomationId))){
            responseType = RenderResponseType.AUTOMATION_NODE;
        } else if (!this.isCustomTabAutomationOnGoing && data.buttons?.length > 0) {
            responseType = RenderResponseType.SMALLTALK;
        }
        return responseType;
    }

    sendRunClickEvent(hostInstance : any, dialog : any, intent = false) {
        this.prepareSendCopyEventForRun(hostInstance, dialog, intent);
        
        let connectionDetails: any = Object.assign({}, this.connectionDetails);
        connectionDetails.value = dialog.intentName;
        if (dialog.intentName && intent) {
          connectionDetails.intentName = dialog.intentName;
        }
        connectionDetails.positionId = dialog.positionId;
        connectionDetails.entities = this.entitiesValueArray
        connectionDetails.childBotId = dialog.childBotId;
        connectionDetails.childBotName = dialog.childBotName;
        connectionDetails.sourceMsgId = dialog.sourceMsgId || '';
    
        if(dialog.taskRefId){
          connectionDetails.taskRefId = dialog.taskRefId
        }
        if(dialog.dialogId){
          connectionDetails.dialogId = dialog.dialogId
        }
        if (dialog.userInput) {
          connectionDetails.userInput = dialog.userInput;
        }
        if (dialog.traits && dialog.traits?.length > 0){
          connectionDetails.traits = dialog.traits
        }
        if(dialog.intentName === ProjConstants.DISCARD_ALL && !intent){
          connectionDetails.isDiscard = true;
        }

        if(dialog.agentRunButton){
            connectionDetails.isSearch = false;
            let myBotRequestParams = hostInstance.prepareAgentAssistAgentRequestParams(connectionDetails);
            hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_agent_request, myBotRequestParams);
            this.mybotEntitiestValueArray = [];
        }else if(dialog.customTabInterrupt){
            let assistRequestParams = hostInstance.prepareAgentAssistCustomRequestParams(connectionDetails);
            hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_custom_request, assistRequestParams);
            this.customTabEntitiesValueArray = [];
        }
        else{
            let assistRequestParams = hostInstance.prepareAgentAssistRequestParams(connectionDetails);
            hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_request, assistRequestParams);
            this.entitiesValueArray = [];
        }
        
    }

    prepareSendCopyEventForRun(hostInstance : any, dialog : any, intent = false) {
        let payloadForBE: any = Object.assign({}, this.connectionDetails);
        if (dialog.intentName && intent) {
            payloadForBE.intentName = dialog.intentName;
            payloadForBE.title = dialog.intentName;
        }
        payloadForBE.type = 'dialog';
        payloadForBE.input = dialog.userInput;
        payloadForBE.sessionId = (dialog.suggestionFrom === ProjConstants.ASSIST || dialog.suggestionFrom === ProjConstants.CUSTOM) ? this.assistTabSessionId : this.myBotTabSessionId;
        payloadForBE = this.addSourceMsgIdToRequestParams(dialog, payloadForBE);
        hostInstance.socketConnection.emitEvents(EVENTS.agent_send_or_copy, payloadForBE);
    }


    matchDialogIdfromMenuResponse(dialog : any){    
        let taskRefId = dialog.taskRefId;
        if(taskRefId && this.menuResponse && this.menuResponse?.length > 0){
          let response : any = this.menuResponse?.find((obj : any) => obj.taskRefId === taskRefId);
          if(response && response.dialogId){
            dialog.dialogId = response.dialogId;
          }
        }
        return dialog.dialogId;
    }

    addEventListenerForDialogSuggestion(menuHTML:any ,suggestion:any , hostInstance: any){
        hostInstance.eventManager?.addEventListener(
            `${this.classConstants.DIALOG_RUN_BTN}${suggestion.positionId}`,
            'click',
            (e: any) => {
                if(suggestion?.customTabInterrupt){
                    suggestion.customTabInterrupt = false;
                }
                suggestion.agentRunButton = false;
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.RUN_CLICK_EVENT, data: suggestion });
                hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, JSON.parse(JSON.stringify(suggestion)));
            },
            menuHTML
        );

        hostInstance.eventManager?.addEventListener(
            `${this.classConstants.DIALOG_AGENT_RUN_BTN}${suggestion.positionId}`,
            'click',
            (e: any) => {
                e.stopPropagation(); // Stop event from bubbling
                suggestion.agentRunButton = true;
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.RUN_CLICK_EVENT, data: suggestion });
                hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, JSON.parse(JSON.stringify(suggestion)));
            },
            menuHTML
        );
    }


    handleDialogClickEvents (menuHTML : any, dialogs : any, hostInstance : any) {

        dialogs?.forEach((suggestion : any, index : number) => {

            const suggestionsHtmlList = menuHTML?.querySelectorAll(`${this.classConstants.DIALOG_RUN_BTN}${suggestion.positionId}`);
            const agentRunButtonHtmlList = menuHTML?.querySelectorAll(`${this.classConstants.DIALOG_AGENT_RUN_BTN}${suggestion.positionId}`);

            if(suggestionsHtmlList && suggestionsHtmlList?.length > 1){
                suggestionsHtmlList?.forEach((itemList: any) => {
                    itemList?.addEventListener('click', (e: any) => {
                        e.stopPropagation(); // Stop event from bubbling
                        e.stopImmediatePropagation(); // Stop event from bubbling

                        if(e.currentTarget === e.target || e.currentTarget.contains(e.target)){
                            if(suggestion?.customTabInterrupt){
                                suggestion.customTabInterrupt = false;
                            }
                            suggestion.agentRunButton = false;
                            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.RUN_CLICK_EVENT, data: suggestion });
                            hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, JSON.parse(JSON.stringify(suggestion)));
                        }
                    });
                });
            }

            if(agentRunButtonHtmlList && agentRunButtonHtmlList?.length > 1){
                agentRunButtonHtmlList?.forEach((itemList: any) => {
                    itemList?.addEventListener('click', (e: any) => {
                        e.stopPropagation(); // Stop event from bubbling
                        e.stopImmediatePropagation(); // Stop event from bubbling

                        if(e.currentTarget === e.target || e.currentTarget.contains(e.target)){
                            suggestion.agentRunButton = true;
                            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.RUN_CLICK_EVENT, data: suggestion });
                            hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, JSON.parse(JSON.stringify(suggestion)));
                        }
                    });
                });
            }

            if(agentRunButtonHtmlList?.length > 1 || suggestionsHtmlList?.length > 1){
                return;
            }

            this.addEventListenerForDialogSuggestion(menuHTML, suggestion, hostInstance);
        });

        hostInstance.eventManager?.addEventListener(
            `${this.classConstants.WRONG_SUGGESTION_BTN}`,
            'click',
            (e: any) => {
                const footerTag = hostInstance.chatEle.querySelector(this.classConstants.FOOTER);
                hostInstance.openSearchTab(footerTag, true);
            },
            menuHTML
        );
    }

    // removeRunwithAgentInputs(menuHTML: any) {
    //     // Get all currently open dropdowns
    //     const openDropdowns = menuHTML?.querySelectorAll('.aa-elipse-dropdown.show');
    //     // Close only the other dropdowns, not the one that was just clicked
    //     openDropdowns?.forEach((element: any) => {
    //         // Check if this dropdown was the one that triggered the event
    //         if (!element.contains(event?.target as Node)) {
    //             element.classList.remove('show');
    //         }
    //     });
    // }


    runDialogForAssistOrMybot(hostInstance: any, dialog: any, runInitent = false) {
        if (!runInitent) {
            this.sendRunClickEvent(hostInstance, dialog, true);
        }
        if (dialog.agentRunButton) {
            this.updateLocalStorageForMybot(hostInstance, dialog, true);
        } else if(dialog.customTabInterrupt){
            this.updateLocalStorageForCustomTab(hostInstance, dialog, true);
        } else {
            this.updateLocalStorageForAssist(hostInstance, dialog, true);
        }
    }

    updateLocalStorageForAssist(hostInstance : any, dialog : any, flag : boolean) {
        this.isAutomationOnGoing = flag;
        this.updateAssistDialogTemplate(hostInstance, dialog, flag);        
    }

    updateLocalStorageForMybot(hostInstance : any, dialog : any, flag : boolean) {
        this.isMyBotAutomationOnGoing = flag;
        this.updateMybotDialogTemplate(hostInstance, dialog, flag);        
    }

    updateLocalStorageForCustomTab(hostInstance : any, dialog : any, flag : boolean) {
        this.isCustomTabAutomationOnGoing = flag;
        this.updateCustomTabDialogTemplate(hostInstance, dialog, flag);        
    }

    updateCustomTabDialogTemplate(hostInstance : any, dialog : any, flag : boolean){
        let termianteBtn = hostInstance.chatEle?.querySelector(`${this.classConstants.CUSTOM_TAB_TERMINATE_BTN  }`);
        let listviewBtn =  hostInstance.chatEle?.querySelector(`${this.classConstants.CUSTOM_TAB_LISTVIEW_BTN}`);
        let customTabHeaderDialogWrapper = hostInstance?.chatEle?.querySelector(`${this.classConstants.CUSTOM_TAB_HEADER_DIALOG_WRAPPER}`);
        let customTabHeaderDialogName = customTabHeaderDialogWrapper?.querySelector(`${this.classConstants.CUSTOM_TAB_HEADER_DIALOG_NAME}`);
        if(flag){
            termianteBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            listviewBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            termianteBtn?.removeAttribute(this.classConstants.DISABLED);
            listviewBtn?.removeAttribute(this.classConstants.DISABLED);
            customTabHeaderDialogWrapper?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            if(customTabHeaderDialogName){
                customTabHeaderDialogName.innerText = dialog.intentName;
            }
        }
        else{            
            termianteBtn?.setAttribute(this.classConstants.DISABLED, true);
            listviewBtn?.setAttribute(this.classConstants.DISABLED, true);
            customTabHeaderDialogWrapper?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }

        
    }

    updateMybotDialogTemplate(hostInstance : any, dialog : any, flag : boolean){        
        let termianteBtn = hostInstance.chatEle?.querySelector(`${this.classConstants.MYBOT_TERMINATE_BUTTON}`);
        let listviewBtn =  hostInstance.chatEle?.querySelector(`${this.classConstants.MYBOT_LISTVIEW_BUTTON}`);
        let mybotHeaderDialogWrapper = hostInstance?.chatEle?.querySelector(`${this.classConstants.MYBOT_HEADER_DIALOG_WRAPPER}`);
        let mybotHeaderDialogName = mybotHeaderDialogWrapper?.querySelector(`${this.classConstants.MYBOT_HEADER_DIALOG_NAME}`);
        if(flag){
            termianteBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            listviewBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            mybotHeaderDialogWrapper?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            mybotHeaderDialogName.innerText = dialog.intentName;
        }else{            
            this.manualAssistOverrideMode = false;
            termianteBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);
            listviewBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);
            mybotHeaderDialogWrapper?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }
    }

    updateAssistDialogTemplate(hostInstance : any, dialog : any, flag : boolean){        
        let termianteBtn = hostInstance.chatEle?.querySelector(`${this.classConstants.ASSIST_TERMINATE_BUTTON}`);
        let listviewBtn =  hostInstance.chatEle?.querySelector(`${this.classConstants.ASSIST_LISTVIEW_BUTTON}`);
        let assistHeaderDialogWrapper = hostInstance?.chatEle?.querySelector(`${this.classConstants.ASSIST_HEADER_DIALOG_WRAPPER}`);
        let assistHeaderDialogName = assistHeaderDialogWrapper?.querySelector(`${this.classConstants.ASSIST_HEADER_DIALOG_NAME}`);
        if(flag){
            termianteBtn?.removeAttribute(this.classConstants.DISABLED);
            listviewBtn?.removeAttribute(this.classConstants.DISABLED);
            assistHeaderDialogWrapper?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            assistHeaderDialogName.innerText = dialog.intentName;
        }else{            
            this.manualAssistOverrideMode = false;
            termianteBtn?.setAttribute(this.classConstants.DISABLED, true);
            listviewBtn?.setAttribute(this.classConstants.DISABLED, true);
            assistHeaderDialogWrapper?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }
    }

    prepareDialogObjForAssistHistory(data : any){
        let dialogObj = this.prepareDialogObjForInitDialog(data);
        return dialogObj;
    }

    prepareDialogObjForMybotHistory(data : any){
        let dialogObj = this.prepareDialogObjForInitDialog(data);
        dialogObj.suggestionFrom = ProjConstants.MYBOT;
        return dialogObj;
    }

    prepareDialogObjForCustomTabHistory(data : any){
        let dialogObj = this.prepareDialogObjForInitDialog(data);
        dialogObj.suggestionFrom = ProjConstants.CUSTOM;
        return dialogObj;
    }

    prepareDialogObjForInitDialog (data : any) {
        let initDialogrenderResp : any = {
            intentName: data.intentName,
            childBotId: data.childBotId,
            childBotName: data.childBotName,
            entities: data.entities || [],
            userInput: data.userInput,
            sourceMsgId: data.sourceMsgId || '',
            positionId : data.positionId,
            traits : data.traits || [],
            dialogId : data.dialogId ? data.dialogId : this.matchDialogIdfromMenuResponse(data),
            suggestionFrom : ProjConstants.ASSIST
        }
        return initDialogrenderResp;
    }

    prepareSuggestionResponse (data: any, responseId: string, suggestionIndex : number) {
        const searchResponse = this.formatSearchResponse(data, false, suggestionIndex, ProjConstants.ASSIST);
        let assistDataNode = {
            data: data,
            type: RenderResponseType.SUGGESTIONS,
            uuid: responseId,
            searchResponse: searchResponse
        }
        return assistDataNode;
    }

    prepareAutomationReponse (res : any, responseId : string, tab : string) {
        if(tab === ProjConstants.ASSIST){
            this.currentAutomationId =  res.positionId;
        }else if(tab === ProjConstants.MYBOT){
            this.currentMybotAutomationId = res.positionId;
        }else{
            this.currentCustomTabAutomationId = res.positionId;
        }
        let renderResponse = {
            data: res,
            type: RenderResponseType.AUTOMATION,
            uuid: responseId,
            dialogId: res.positionId,
            dialogName: res.intentName,
            sourceMsgId : res.sourceMsgId || "",
            automationNodes : [this.prepareDialogStartNodeResponse(res.positionId)]
          }
          return renderResponse;
    }

    prepareAutomationNodeResponse (data: any, responseId : string) {
        let renderResponse: any = {
            data: data,
            type: RenderResponseType.AUTOMATION_NODE,
            uuid: responseId
          }
          return renderResponse;
    }

    prepareDialogStartNodeResponse (dialogId : string){
        let renderResponse : any = {
            type : RenderResponseType.AUTOMATION_START,
            uuid : KoreGenerateuuidPipe(),
            dialogId : dialogId
        }
        return renderResponse
    } 

    prepareDialogEndNodeResponse (dialogId : string) {
        let renderResponse : any = {
            type : RenderResponseType.AUTOMATION_END,
            uuid : KoreGenerateuuidPipe(),
            dialogId : dialogId
        }
        return renderResponse;
    }

    prepareEntityNodeResponse(response : any, dataObj : any, hostInstance : any) {
        let templateRender = response?.templateResult?.parsedPayload ? true : false;
        dataObj.nodeType = RenderResponseType.ENTITY_NODE;
        dataObj.value = response?.buttons[0]?.value;
        dataObj.sendData = response?.buttons[0]?.value;
        dataObj.template = this.getTemplateHtml(templateRender, response.templateResult, hostInstance);
        dataObj.templateRender = templateRender;
        if(dataObj?.attachments){
            dataObj.userInput = response?.userInput;
        }
        return dataObj;
    }

    prepareMsgNodeResponse (response : any, dataObj : any, hostInstance : any) {
        let templateRender = response?.templateResult?.parsedPayload ? true : false;
        dataObj.nodeType = RenderResponseType.MSG_NODE;
        dataObj.value = response?.buttons[0]?.value;
        dataObj.sendData = response?.buttons[0]?.value;
        dataObj.template = this.getTemplateHtml(templateRender, response.templateResult, hostInstance);
        dataObj.templateRender = templateRender;
        return dataObj;
    }

    prepareSmallTalkResponse (data: any, responseId : string) {
        let renderResponse: any = {
            data: data,
            type: RenderResponseType.SMALLTALK,
            uuid: responseId
          }
          return renderResponse;
    }

    prepareWelcomeMsgResponse (data: any, responseId: string) {
        let assistDataNode: any = {
            data: data,
            type: RenderResponseType.WELCOME_MSG,
            uuid : responseId,
            hideOverrideDiv : true,
            toggleOverride : false,
            nodeType : RenderResponseType.MSG_NODE
          }
          return assistDataNode;
    }

    toggleInterruptPopup = (hostInstance : any, flag : boolean, currentDialogName : string) => {
        let interruptPopup = hostInstance?.chatEle?.querySelector?.(`${this.classConstants.INTERRUPT_POPUP}`);
        if(flag){
            interruptPopup.querySelector(`${this.classConstants.INTERRUPT_CURRENT_DIALOG}`).innerText = currentDialogName;
            interruptPopup.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
        }else{
            interruptPopup.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
        }
    }

    toggleTerminatePopup = (hostInstance : any, flag : boolean) => {
        let terminatePopup = hostInstance?.chatEle?.querySelector?.(`${this.classConstants.TERMIANTE_POPUP}`);
        if(flag){
            terminatePopup.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
        }else{
            terminatePopup.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
        }
    }

    toggleInterruptDropdown (tab : string, hostInstance : any) {
        let dialogWrapper = this.classConstants.ASSIST_INTERRUPT_WRAPPER;
        let interruptCount = this.classConstants.ASSIST_INTERRUPT_COUNT;
        hostInstance.localStorageService.setInterruptDialogList(this.interruptDialogList);
        let interruptDialogWrapper = hostInstance?.chatEle?.querySelector(`${dialogWrapper}`)
        if(this.interruptDialogList?.length > 0){
            interruptDialogWrapper?.classList?.remove(this.classConstants.HIDE_ELEMENT);
        }else{
            interruptDialogWrapper?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }
        let interruptCountEle = interruptDialogWrapper?.querySelector(`${interruptCount}`);
        if(interruptCountEle){
           interruptCountEle.innerText = this.interruptDialogList?.length;
        }
    }

    toggleMybotInterruptDropdown(tab : string, hostInstance : any){        
        let dialogWrapper = this.classConstants.MYBOT_INTERRUPT_WRAPPER;
        let interruptCount = this.classConstants.MYBOT_INTERRUPT_COUNT;
        hostInstance.localStorageService.setInterruptDialogList(this.mybotInterruptDialogList);
        let interruptDialogWrapper = hostInstance?.chatEle?.querySelector(`${dialogWrapper}`)
        if(this.mybotInterruptDialogList?.length > 0){
            interruptDialogWrapper?.classList?.remove(this.classConstants.HIDE_ELEMENT);
        }else{
            interruptDialogWrapper?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }
        let interruptCountEle = interruptDialogWrapper?.querySelector(`${interruptCount}`);
        if(interruptCountEle){
           interruptCountEle.innerText = this.mybotInterruptDialogList?.length;
        }
    }

    toggleCustomTabInterruptDropdown(tab : string, hostInstance : any){
        let dialogWrapper = this.classConstants.CUSTOM_TAB_INTERRUPT_WRAPPER;
        let interruptCount = this.classConstants.CUSTOM_TAB_INTERRUPT_COUNT;
        hostInstance.localStorageService.setInterruptDialogList(this.customInterruptDialogList);
        let interruptDialogWrapper = hostInstance?.chatEle?.querySelector(`${dialogWrapper}`)
        if(this.customInterruptDialogList?.length > 0){
            interruptDialogWrapper?.classList?.remove(this.classConstants.HIDE_ELEMENT);
        }else{
            interruptDialogWrapper?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }
        let interruptCountEle = interruptDialogWrapper?.querySelector(`${interruptCount}`);
        if(interruptCountEle){
           interruptCountEle.innerText = this.customInterruptDialogList?.length;
        }
    }

    handleEmptyLine(answer : any, quotflag = false, type : string = '', hostInstace : any) {
        let eleanswer = '';
        if (typeof answer === 'string') {
          eleanswer = (type === 'faq') ? answer.replace(/(\r\n|\n|\r)/gm, "<br>") : answer;          
           eleanswer = this.replaceLtGt(eleanswer, quotflag)
           eleanswer = this.aaHelpers.convertMDtoHTML(eleanswer, "bot", eleanswer)
          // if (quotflag) {
          //   eleanswer = this.replaceLtGt(eleanswer, quotflag)
          // }          
          return this.sanitizeHTML(eleanswer.replace(new RegExp("(<br />)+$"),''));
    
        }
        return this.sanitizeHTML(eleanswer);
    }

    replaceLtGt(htmlString : any, quotflag : boolean) {
        let newHtmlStr;
        newHtmlStr = htmlString.replaceAll("&lt;", "<");
        newHtmlStr = newHtmlStr.replaceAll("&gt;", ">");
        if (quotflag) {
          newHtmlStr = newHtmlStr.replaceAll('"', "&quot;");
        }
        return newHtmlStr;
      }

    // Welocome message logic starts
    handleWelcomeMsgResponse(
        welcomeMsgResponse: any,
        template: HTMLElement,
        hostInstance: any
    ) {
        welcomeMsgResponse.buttons.forEach((message: any, index: number) => {
            const welcomeMsgObj = this.createWelcomeMessageObject(message.value, index);
            this.insertActionTemplate(welcomeMsgObj, index, template, hostInstance);
        });
    }

    handleNodeResponse(
        automationNodeObj: any,
        template: HTMLElement,
        hostInstance: any
    ) {
        this.insertActionTemplate(automationNodeObj, null, template, hostInstance);
    }

    insertActionTemplate(
        nodeObj: any,
        index: number | null,
        template: HTMLElement,
        hostInstance: any
    ) {
        const eachActionTemplate: any = getHTML(
            handleSendCopyButtonsForNodes,
            { node: nodeObj, hostInstance: hostInstance, rootServiceInstance: hostInstance.rootService },
            hostInstance
        );
        if (eachActionTemplate && eachActionTemplate?.nodeName !== '#text') {
            const parentNode = this.getParentNode(template, index);
            if(parentNode && this.isHistory && typeof this.prefsOpacity === 'number'){
                template.style.opacity = String(this.prefsOpacity/100)
            }
            if (parentNode) {
                parentNode.insertBefore(eachActionTemplate, parentNode.firstChild);
                this.handleActionTemplateClickEventsForNodes(
                    eachActionTemplate,
                    nodeObj,
                    template,
                    hostInstance
                );
            }
        }
    }

    getParentNode(template: HTMLElement, index: number | null): HTMLElement | null {
        if (index !== null) {
            return template?.querySelector(`${this.classConstants.WELCOME_MSG_NODE}${index}`);
        }
        return template?.querySelector(this.classConstants.NODE_BODY);
    }

    createWelcomeMessageObject(value: string, index: number) {
        return {
            sendData: value,
            index: index,
            type: RenderResponseType.WELCOME_MSG,
        };
    }

    handleActionTemplateClickEventsForNodes(
        eachActionTemplate: HTMLElement,
        automationNodeObj: any,
        template: HTMLElement,
        hostInstance: any
    ) {
        const sendTextTemplate: any = template.querySelector?.(`${this.classConstants.NODE_SEND_TEXT}`);

        this.addClickEventListenerForActionNodes(
            eachActionTemplate,
            this.classConstants.SUGGESTION_SEND_BTN,
            () => this.handleSendOrCopyClickEvent(ProjConstants.SEND, sendTextTemplate, automationNodeObj, template, hostInstance),
            hostInstance
        );

        this.addClickEventListenerForActionNodes(
            eachActionTemplate,
            this.classConstants.SUGGESTION_COPY_BTN,
            () => this.handleSendOrCopyClickEvent(ProjConstants.COPY, sendTextTemplate, automationNodeObj, template, hostInstance),
            hostInstance
        );
    }

    addClickEventListenerForActionNodes(
        template: HTMLElement,
        eventSelector: string,
        callback: () => void,
        hostInstance: any
    ) {
        hostInstance.eventManager?.addEventListener(eventSelector, 'click', callback, template);
    }
    // Welocome message logic ends

    //Send copy click events handling logic starts
    handleSendOrCopyClickEvent(
        type: string,
        sendTextTemplate: HTMLElement | null,
        automationNodeObj: any,
        template: HTMLElement,
        hostInstance: any
    ) {
        if(typeof this.prefsOpacity === 'number'){
            template.style.opacity = String((this.prefsOpacity/100))
        }
        this.toggleSendTextTemplate(sendTextTemplate, type);
        this.handleSendCopyButtonForNodes(type, automationNodeObj.sendData, automationNodeObj, template, hostInstance);
        automationNodeObj.skipMsg = true;

        if (automationNodeObj.type === RenderResponseType.WELCOME_MSG) {
            this.removeWelcomeMessages(automationNodeObj, hostInstance);
        }

        if(type === ProjConstants.SEND){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, { event: SDK_EVENTS.AGENT_SEND_MESSAGE, data: automationNodeObj, template : automationNodeObj?.data?.template ? automationNodeObj?.data?.template : false, msg : automationNodeObj?.sendData });
        }else{
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, { event: SDK_EVENTS.AGENT_COPY_MESSAGE, data: automationNodeObj, template : automationNodeObj?.data?.template ? automationNodeObj?.data?.template : false, msg : automationNodeObj?.sendData });
        }
    }

    toggleSendTextTemplate(sendTextTemplate: HTMLElement | null, type: string) {
        if (!sendTextTemplate) return;
        sendTextTemplate.classList.remove(this.classConstants.HIDE_ELEMENT);
        sendTextTemplate.innerText = type === ProjConstants.SEND ? 'Sent' : 'Copied';
    }

    removeWelcomeMessages(automationNodeObj: any, hostInstance: any) {
        const welcomeMsgNodes: NodeListOf<Element> | undefined =
            hostInstance?.chatEle?.querySelectorAll(`${this.classConstants.WELCOME_NODES}`);

        welcomeMsgNodes?.forEach((node) => {
            if (!node.classList.contains(`aa-welcome-msg-${automationNodeObj.index}`)) {
                node.parentNode?.removeChild(node);
            }
        });
    }

    handleSendCopyButtonForNodes(
        actionType: string,
        sendData: any,
        automation: any,
        template: HTMLElement,
        hostInstance: any
    ) {
        let node : any = template.querySelector?.(`${this.classConstants.NODE_BODY}`)?.querySelector('p');
        sendData = this.prepareSendText(sendData, automation.templateRender, node);
        const message = this.createMessagePayload(actionType, sendData);
        console.log(`🚀  ~ agentAssist.${actionType === ProjConstants.SEND ? 'SendMessage' : 'CopyMessage'} for message nodes`, sendData);
        this.messageNodeSendorCopyEvent(actionType, sendData, automation, hostInstance);
    }

    prepareSendText(sendData : any, templateRender : any, askCustNode : any){
        if(!templateRender){
            let format = this?.aaSettings?.agentActions?.sharingFormat ? this?.aaSettings?.agentActions?.sharingFormat : 'plainString';
          if(format == 'plainString'){
            sendData = this.extractTextFromElement(askCustNode);
          }
        }
        return sendData;
      }

    createMessagePayload(actionType: string, sendData: any) {
        return {
            method: actionType === ProjConstants.SEND ? 'send' : 'copy',
            name: actionType === ProjConstants.SEND ? ProjConstants.SENDMSG : ProjConstants.COPYMSG,
            conversationId: this.connectionDetails.conversationId,
            payload: sendData,
        };
    }

    messageNodeSendorCopyEvent(
        eventName: string,
        payload: any,
        automation: any,
        hostInstance: any
    ) {
        const payloadForBE = this.buildBackendPayload(eventName, payload, automation);
        hostInstance.socketConnection.emitEvents(EVENTS.agent_send_or_copy, payloadForBE);
    }

    buildBackendPayload(
        eventName: string,
        payload: any,
        automation: any
    ): any {
        const basePayload : any = {
            usedType: eventName === ProjConstants.SEND ? ProjConstants.SEND_METHOD : ProjConstants.COPY_METHOD,
            name: eventName === ProjConstants.SEND ? ProjConstants.SENDMSG : ProjConstants.COPYMSG,
            conversationId: this.connectionDetails.conversationId,
            payload: payload,
            botId: this.connectionDetails.botId,
            positionId: automation?.dialogId,
            type: 'sentence',
            sessionId: this.getSessionId(),
            skipMsg: automation?.data?.errorMsg || automation.skipMsg || false,
        };

        if (automation?.data?.isPrompt && automation?.data?.componentType) {
            basePayload.componentType = automation.data.componentType;
        } else if (!automation?.data?.isPrompt) {
            basePayload.partialMessage = true;
        }

        return this.addSourceMsgIdToRequestParams(automation, basePayload);
    }

    getSessionId(): string {
        return this.activeTab === Tabs.MYBOT ? this.myBotTabSessionId : this.assistTabSessionId;
    }
    //Send copy click events handling logic ends

    // Feedback logic for suggestions and automations starts
    renderFeedbackForEachSuggestion (suggestionListTemplate : any, suggestionList : any, feedbackType: string, hostInstance : any) {
        if(this.aaSettings?.feedback[feedbackType]?.isEnabled){
            suggestionListTemplate?.forEach((suggestionTemplate : any, index : number) => {
                let positionId = suggestionList[index]?.positionId;
                let feedbackWrapperTemplate : any = getHTML(FeedbackWrapperInsideDialog, {dialog : {dialogId : positionId}}, hostInstance);
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, feedbackWrapperTemplate, {
                    event: SDK_EVENTS.FEEDBACK_WRAPER_TEMPLATE,
                    data : {dialog : {dialogId : positionId}}
                });
                suggestionTemplate.append(feedbackWrapperTemplate);  
                this.handleFeedbackType({dialogId : positionId, feedbackData : suggestionList[index]?.feedbackData}, suggestionTemplate, feedbackType, hostInstance);
            });
        }
    }
        
    handleFeedbackType(automation: any, dialogWrapper: any, feedbackType : string, hostInstance: any) {
        let dislikeList : any = [];
    
        let language = this.connectionDetails?.interactiveLanguage || 'en';
        language = (FeebackConst.DEFAULT_FEEDBACK_LANGUAGE_LIST.indexOf(language.toLowerCase()) != -1) ? language.toLowerCase() : 'en';
        const suggestionList = (this.aaSettings?.feedback[feedbackType]?.negativeKeyWords?.[language]) ?
            this.aaSettings?.feedback[feedbackType]?.negativeKeyWords?.[language] : this.defaultFeedbackSettings[feedbackType]?.negativeKeyWords?.[language];
        suggestionList?.forEach((element: any) => {
            if (element.isEnabled) {
                dislikeList.push(element.key);
            }
        });
        const showComments = this.aaSettings?.feedback[feedbackType]?.acceptComment;    

        const feedbackHelpfulSection = dialogWrapper?.querySelector?.(`${this.classConstants.FEEDBACK_HELPFUL_SECTION}${automation.dialogId}`);
        const feedbackWrapper = dialogWrapper?.querySelector?.(`${this.classConstants.FEEDBACK_WRAPPER}${automation.dialogId}`);
    
        const helpSection = getHTML(HelpfulFeedbackSection, { feedbackData : automation?.feedbackData, dialogId: automation.dialogId, suggestionList: dislikeList, showComments, feedbackType }, hostInstance);

        const negativeFeedbackSection = getHTML(NegativeFeedbackSection, { feedbackData : automation?.feedbackData, suggestionList: dislikeList, dialogId: automation.dialogId, hostInstance, feedbackType, showComments }, hostInstance);
        
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, helpSection, {
            event: SDK_EVENTS.HELPFUL_FEEDBACK_TEMPLATE,
            data : { dialogId: automation.dialogId }
        });

        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, negativeFeedbackSection, {
            event: SDK_EVENTS.NEGATIVE_FEEDBACK_TEMPLATE,
            data : { suggestionList: dislikeList, dialogId: automation.dialogId }
        });

        helpSection && feedbackHelpfulSection?.append(helpSection);
        negativeFeedbackSection && feedbackWrapper?.append(negativeFeedbackSection);
    
        this.handleFeebackClickEvents(helpSection, negativeFeedbackSection, feedbackWrapper, dislikeList, showComments, automation, hostInstance);
    }
    // Feedback logic  for suggestions and automations ends

    //Feedback click events start
    handleFeebackClickEvents(
        helpSection: any,
        negativeFeedbackSection: any,
        feedbackWrapper: any,
        dislikeList: any,
        showComments : boolean,
        automation: any,
        hostInstance: any
      ) {
        // Helper to add event listeners
        const addEvent = (selector: string, event: string, handler: (e: any) => void, element: any) => {
          hostInstance.eventManager?.addEventListener(selector, event, handler, element);
        };
      
        // Helper to toggle classes
        const toggleClass = (element: any, className: string, action: 'add' | 'remove' | 'toggle') => {
          element.classList?.[action](className);
        };
      
        //check active button
        const activeButton = (btn : any) => {
            return btn?.classList?.contains(this.classConstants.FEEDBACK_ACTIVE_BUTTON);
        }

        // Handle positive feedback
        const handlePositiveFeedback = () => {
          const positiveButton = helpSection.querySelector(`${this.classConstants.FEEDBACK_POSITIVE}`);
          const negativeButton = helpSection.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE}`);
          const negativeArrowBtn = helpSection.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE_DROPDOWN_BTN}`);
          const feedbackNegativeBox = feedbackWrapper.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE_BOX}`);

          if(!activeButton(positiveButton)){
              toggleClass(positiveButton, this.classConstants.FEEDBACK_ACTIVE_BUTTON, 'add');
              toggleClass(negativeButton, this.classConstants.FEEDBACK_ACTIVE_BUTTON, 'remove');
              toggleClass(negativeArrowBtn, this.classConstants.HIDE_ELEMENT, 'add');
              toggleClass(negativeArrowBtn, this.classConstants.FEEDBACK_ROTATE_BTN, 'remove');
              toggleClass(feedbackNegativeBox, this.classConstants.HIDE_ELEMENT, 'add');
              this.prepareAndMakeFeedbackRequest(automation, negativeFeedbackSection, commentBox, helpSection, 'like', dislikeList, showComments, hostInstance);
          }
      
        };
      
        // Handle negative feedback
        const handleNegativeFeedback = () => {
          const positiveButton = helpSection.querySelector(`${this.classConstants.FEEDBACK_POSITIVE}`);
          const negativeButton = helpSection.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE}`);
          const negativeArrowBtn = helpSection.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE_DROPDOWN_BTN}`);
          const feedbackNegativeBox = feedbackWrapper.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE_BOX}`);

          if(showComments || dislikeList?.length > 0){
              toggleClass(negativeArrowBtn, this.classConstants.HIDE_ELEMENT, 'remove');
              toggleClass(feedbackNegativeBox, this.classConstants.HIDE_ELEMENT, 'remove');
              toggleClass(negativeArrowBtn, this.classConstants.FEEDBACK_ROTATE_BTN, 'add');
          }

          if(!activeButton(negativeButton)){
              toggleClass(negativeButton, this.classConstants.FEEDBACK_ACTIVE_BUTTON, 'add');
              toggleClass(positiveButton, this.classConstants.FEEDBACK_ACTIVE_BUTTON, 'remove');
              this.prepareAndMakeFeedbackRequest(automation, negativeFeedbackSection, commentBox, helpSection, 'dislike', dislikeList, showComments, hostInstance);
          }
        };
      
        // Handle dropdown toggle
        const handleDropdownToggle = () => {

          const feedbackNegativeBox = feedbackWrapper.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE_BOX}`);
          const negativeArrowBtn = helpSection.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE_DROPDOWN_BTN}`);
          
          toggleClass(feedbackNegativeBox, this.classConstants.HIDE_ELEMENT, 'toggle');
          toggleClass(negativeArrowBtn, this.classConstants.FEEDBACK_ROTATE_BTN, 'toggle');
        };
      
        // Attach event listeners
        addEvent(this.classConstants.FEEDBACK_POSITIVE, 'click', handlePositiveFeedback, helpSection);
        addEvent(this.classConstants.FEEDBACK_NEGATIVE, 'click', handleNegativeFeedback, helpSection);
        addEvent(this.classConstants.FEEDBACK_NEGATIVE_DROPDOWN_BTN, 'click', handleDropdownToggle, helpSection);
      
        // Handle suggestions click
        dislikeList.forEach((suggestion: any, index: number) => {
          const suggestionClassName = `${this.classConstants.FEEDBACK_SUGGESTION}${automation.dialogId}-${index}`;
          const suggestionEle = negativeFeedbackSection.querySelector(`${suggestionClassName}`);
      
          addEvent(suggestionClassName, 'click', () => {
            toggleClass(suggestionEle, this.classConstants.FEEDBACK_NEGATIVE_SUGGESTION_SELECTION, 'toggle');
          }, negativeFeedbackSection);
        });
      
        // Handle submit feedback
        addEvent(this.classConstants.FEEDBACK_SUBMIT, 'click', () => {
          const feedbackNegativeBox = feedbackWrapper.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE_BOX}`);
          const negativeArrowBtn = helpSection.querySelector(`${this.classConstants.FEEDBACK_NEGATIVE_DROPDOWN_BTN}`);

          toggleClass(feedbackNegativeBox, this.classConstants.HIDE_ELEMENT, 'add');
          toggleClass(negativeArrowBtn, this.classConstants.FEEDBACK_ROTATE_BTN, 'remove');
          this.prepareAndMakeFeedbackRequest(automation, negativeFeedbackSection, commentBox, helpSection, 'submit', dislikeList, showComments, hostInstance);
        }, negativeFeedbackSection);
      
        // Handle comment box input
        const commentBox = negativeFeedbackSection.querySelector(`${this.classConstants.FEEDBACK_COMMENT}${automation.dialogId}`);
        addEvent(`${this.classConstants.FEEDBACK_COMMENT}${automation.dialogId}`, 'input', (e: any) => {
          const commentLength = commentBox?.value?.length || 0;
          negativeFeedbackSection.querySelector(`${this.classConstants.FEEDBACK_COMMENT_COUNT}`).innerText = `${commentLength}/150`;
        }, negativeFeedbackSection);
    }

    handleWidgetFeedbackClickEvents(widgetFeedbackSection: any, type: string, hostInstance: any) {
        const addEvent = (selector: string, event: string, handler: (e: any) => void, element: any) => {
            hostInstance.eventManager?.addEventListener(selector, event, handler, element);
        };

        const toggleClassInSubmitButton = (type = 'positive') => {

            if(type === 'negative' && !this.widgetFeedbackData.selectedSuggestions?.length && !this.widgetFeedbackData.comment?.length){
                hostInstance?.chatEle?.querySelector?.(this.classConstants.FEEDBACK_SUBMIT_BTN)?.setAttribute('disabled', true);
                return;
            }


            if(hostInstance?.chatEle?.querySelector?.(this.classConstants.FEEDBACK_SUBMIT_BTN)?.hasAttribute('disabled')){
                hostInstance?.chatEle?.querySelector?.(this.classConstants.FEEDBACK_SUBMIT_BTN)?.removeAttribute('disabled');
            }
        }

        const handlePositiveFeedbackSection = (widgetFeedbackSection: any) => {

            const positiveSuggestionsBtns = widgetFeedbackSection?.querySelectorAll(this.classConstants.POSITIVE_FEEDBACK);
            const positiveCommentBox = widgetFeedbackSection?.querySelector(this.classConstants.POSITIVE_FEEDBACK_COMMENT);


            const widgetFeedbackData = this.widgetFeedbackData;

            widgetFeedbackData.selectedSuggestions = [];

            if(!widgetFeedbackData.type){
                widgetFeedbackData.type = 'positive';
            }

            positiveSuggestionsBtns?.forEach((suggestionBtn: any) => {
                addEvent(`.${suggestionBtn.classList[1]}`, 'click', (e:any) => {

                    if(widgetFeedbackData.type === 'negative'){
                        handleAlternateFeedbackSection(widgetFeedbackSection, 'negative', widgetFeedbackData);
                    }

                    toggleClassInSubmitButton();

                    if(e && e.target?.value?.length > 0){
                        if(widgetFeedbackData.selectedSuggestions.includes(e.target.value)){
                            widgetFeedbackData.selectedSuggestions = widgetFeedbackData.selectedSuggestions.filter((suggestion: string) => suggestion !== e.target.value);
                            suggestionBtn.classList.remove('active-improve-btn');
                        }else{
                            suggestionBtn.classList.add('active-improve-btn');
                            widgetFeedbackData.selectedSuggestions.push(e.target.value);
                        }
                    }

                }, widgetFeedbackSection);
            });

            addEvent(`.${positiveCommentBox.classList[2]}`, 'input', (e:any) => {
                
                if(widgetFeedbackData.type === 'negative'){
                    handleAlternateFeedbackSection(widgetFeedbackSection, 'negative', widgetFeedbackData);
                }

                toggleClassInSubmitButton();
                widgetFeedbackData.comment = e.target?.value || '';
                const positiveCommentBoxCount = hostInstance?.chatEle?.querySelector(`${this.classConstants.FEEDBACK_COMMENT_COUNT}-${widgetFeedbackData.type}`);
                if(positiveCommentBoxCount){
                   positiveCommentBoxCount.innerText = `${e.target?.value?.length || 0}/150`;
                }

            }, widgetFeedbackSection);
        }

        const handleNegativeFeedbackSection = (widgetFeedbackSection: any) => {
            const negativeSuggestionsBtns = widgetFeedbackSection?.querySelectorAll(this.classConstants.NEGATIVE_FEEDBACK);
            const negativeCommentBox = widgetFeedbackSection?.querySelector(this.classConstants.NEGATIVE_FEEDBACK_COMMENT);


            const widgetFeedbackData = this.widgetFeedbackData;

            widgetFeedbackData.selectedSuggestions = [];

            if(!widgetFeedbackData.type){
                widgetFeedbackData.type = 'negative';
            }

        
            negativeSuggestionsBtns?.forEach((suggestionBtn: any) => {
                addEvent(`.${suggestionBtn.classList[1]}`, 'click', (e:any) => {

                    if(widgetFeedbackData.type === 'positive'){
                        handleAlternateFeedbackSection(widgetFeedbackSection, 'positive', widgetFeedbackData);
                    }

                    if(e && e.target?.value?.length > 0){
                        if(widgetFeedbackData.selectedSuggestions.includes(e.target.value)){
                            widgetFeedbackData.selectedSuggestions = widgetFeedbackData.selectedSuggestions.filter((suggestion: string) => suggestion !== e.target.value);
                            suggestionBtn.classList.remove('active-improve-btn');
                        }else{
                            suggestionBtn.classList.add('active-improve-btn');
                            widgetFeedbackData.selectedSuggestions.push(e.target.value);
                        }
                    }

                    toggleClassInSubmitButton('negative');

                }, widgetFeedbackSection);
            });

            addEvent(`.${negativeCommentBox?.classList[2]}`, 'input', (e:any) => {
                if(widgetFeedbackData.type === 'positive'){
                    handleAlternateFeedbackSection(widgetFeedbackSection, 'positive', widgetFeedbackData);
                }

                widgetFeedbackData.comment = e.target?.value || '';
                toggleClassInSubmitButton('negative');
                const negativeCommentBoxCount = hostInstance?.chatEle?.querySelector(`${this.classConstants.FEEDBACK_COMMENT_COUNT}-${widgetFeedbackData.type}`);
                if(negativeCommentBoxCount){
                   negativeCommentBoxCount.innerText = `${e.target?.value?.length || 0}/150`;
                }
            }, widgetFeedbackSection);
        }


        const handleAlternateFeedbackSection = (widgetFeedbackSection: any, type: string, widgetFeedbackData: any = this.widgetFeedbackData) => {

            if(type === 'negative'){
                const negativeSuggestionsBtns = hostInstance?.chatEle?.querySelectorAll(this.classConstants.NEGATIVE_FEEDBACK);
                const negativeCommentBox = hostInstance?.chatEle?.querySelector(this.classConstants.NEGATIVE_FEEDBACK_COMMENT);
                negativeSuggestionsBtns?.forEach((suggestionBtn: any) => {
                    suggestionBtn.classList.remove('active-improve-btn');
                });
                negativeCommentBox.value = '';
                widgetFeedbackData.selectedSuggestions = [];
                widgetFeedbackData.comment = '';
                widgetFeedbackData.type = 'positive';
            }else{
                const positiveSuggestionsBtns = hostInstance?.chatEle?.querySelectorAll(this.classConstants.POSITIVE_FEEDBACK);
                const positiveCommentBox = hostInstance?.chatEle?.querySelector(this.classConstants.POSITIVE_FEEDBACK_COMMENT);
                positiveSuggestionsBtns?.forEach((suggestionBtn: any) => {
                    suggestionBtn.classList.remove('active-improve-btn');
                });
                positiveCommentBox.value = '';
                widgetFeedbackData.selectedSuggestions = [];
                widgetFeedbackData.comment = '';
                widgetFeedbackData.type = 'negative';
            }

        }

       
        
        if(type === 'positive'){
            handlePositiveFeedbackSection(widgetFeedbackSection);
        }else{
            handleNegativeFeedbackSection(widgetFeedbackSection);
        }
    }


    prepareAndMakeWidgetFeedbackRequest(hostInstance: any) {
        const { botId, conversationId, channel } = this.connectionDetails;

        const feedbackType = this.widgetFeedbackData.type && (this.widgetFeedbackData.type === 'positive' ? 'like' : 'dislike') || null;
        const feedbackSuggestions = this.widgetFeedbackData.selectedSuggestions;
        const feedbackComment = this.widgetFeedbackData.comment;

        if(!this.widgetFeedbackData.positionId){
            this.widgetFeedbackData.positionId = RandomuuidPipe('positionId') as string;
        }

        const feedbackDetails = {
            botId,
            conversationId,
            event: EVENTS.agent_usage_feedback,
            positionId: this.widgetFeedbackData.positionId,
            experience: channel,
            feedback: feedbackType ,
            feedbackDetails: feedbackSuggestions,
            comment: feedbackComment || '',
            type: 'widget',
            interactionType: 'widget'
        }

        hostInstance.socketConnection.emitEvents(EVENTS.agent_usage_feedback, feedbackDetails);
    }

    prepareAndMakeFeedbackRequest(
        automation: any, 
        negativeFeedbackSection: HTMLElement, 
        commentBox: HTMLInputElement, 
        helpSection: HTMLElement,
        type : string,
        dislikeList : any,
        showComments : boolean,
        hostInstance : any
      ) {
        
        let feedbackData = automation?.feedbackData;
        const { botId, conversationId, channel } = this.connectionDetails;
        const feedbackList: string[] = [];
      
        const activeSuggestionBtnList = negativeFeedbackSection.querySelectorAll(
          `.${this.classConstants.FEEDBACK_NEGATIVE_SUGGESTION_SELECTION}`
        );
        
        activeSuggestionBtnList.forEach((suggestionEle: Element) => {
            const inputElement = suggestionEle as HTMLInputElement;
            if (inputElement?.value) feedbackList.push(inputElement.value);
          });
      
        const activeFeedback = (helpSection
          ?.querySelector(`.${this.classConstants.FEEDBACK_ACTIVE_BUTTON}`) as HTMLInputElement)
          ?.value;
      
        const feedbackDetails: any = {
          botId,
          conversationId,
          event: EVENTS.agent_usage_feedback,
          positionId: feedbackData.positionId,
          experience: channel,
          feedback: activeFeedback || null,
          feedbackDetails: feedbackList,
          comment: commentBox?.value || '',
        };
      
        if (feedbackData.suggestionType) {
          const {
            sourceMsgId, suggestionType, query, subType, title, answer,
            sources, isFromGeneratedSummary, answerType, interactionType
          } = feedbackData;
      
          Object.assign(feedbackDetails, {
            sourceMsgId,
            type: suggestionType,
            query,
            subType,
            title,
            answer,
            interactionType
          });
      
          if (suggestionType === 'answer') {
            Object.assign(feedbackDetails, {
              sources,
              isFromGeneratedSummary,
              answerType
            });
          }
        } else {
          feedbackDetails.taskId = feedbackData.uuid;
          feedbackDetails.taskName = feedbackData.dialogName;
          feedbackDetails.type = 'dialog';
          feedbackDetails.interactionType = this.activeTab == Tabs.ASSIST ? 'assist' : this.activeTab == Tabs.CUSTOM_TAB ? 'custom' : 'mybot'
        }

        if(feedbackData?.suggestionType === 'summary'){
          feedbackDetails.summaryId = feedbackData?.summaryId;
          feedbackDetails.traceId = feedbackData?.traceId;
        }
        this.isUpdateFeedBackDetailsFlag = type != 'dislike' || (dislikeList?.length === 0 && !showComments) ? true : false;
        hostInstance.socketConnection.emitEvents(EVENTS.agent_usage_feedback, feedbackDetails);
    }
    //Feedback click events end

    //smalltalk template code starts 
    addSmallTalkTemplate (smallTalkObj: any, activeTab: string, hostInstance : any) {
        const mybotWrapper = hostInstance?.chatEle?.querySelector(`${this.classConstants.MYBOT_SECTION}`);
        const assistWrapper = hostInstance?.chatEle?.querySelector(`${this.classConstants.ASSIST_SECTION}`);
        const customWrapper = hostInstance?.chatEle?.querySelector(`${this.classConstants.CUSTOM_TAB_SECTION}`);
        const template = this.getSmallTalkTemplate(smallTalkObj, activeTab, hostInstance);
      
        if (template && assistWrapper && activeTab === ProjConstants.ASSIST) {
          assistWrapper.append(template);
        } else if (template && mybotWrapper && activeTab === ProjConstants.MYBOT) {
          mybotWrapper.append(template);
        }
        else if (template && customWrapper && activeTab === ProjConstants.CUSTOM) {
          customWrapper.append(template);
        }
      };
      
    getSmallTalkTemplate (smallTalkObj: any, activeTab: string, hostInstance : any): HTMLElement | null {
        let template: any = null;
      
        switch (smallTalkObj.nodeType) {
          case RenderResponseType.ENTITY_NODE:
            let manualMode = this.manualAssistOverrideMode || !this.proactiveMode;
            let payload : any = { entityNode: smallTalkObj, activeTab, manualMode, hostInstance }
            template = getHTML(AskCustomer, payload , hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                event: SDK_EVENTS.ASK_CUSTOMER_TEMPLATE,
                data : payload
            });
            this.appendTemplate(template,smallTalkObj);
            this.handleNodeResponse(smallTalkObj, template, hostInstance);
            this.handleEntityNodeClickEvents(template, smallTalkObj, activeTab, hostInstance);
            break;
      
          case RenderResponseType.MSG_NODE:
            template = getHTML(TellCustomer, { msgNode: smallTalkObj, hostInstance }, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                event: SDK_EVENTS.TELL_CUSTOMER_TEMPLATE,
                data : smallTalkObj
            });
            this.appendTemplate(template,smallTalkObj);
            this.handleNodeResponse(smallTalkObj, template, hostInstance);
            break;
        }
      
        return template;
      };
      //smallTalk template code ends

    // Automation template code starts
    addDialogTemplate(automationNodeObj: any, automation: any, activeTab: string, hostInstance: any) {
        const dialogWrapper = this.getDialogWrapper(hostInstance, automation.dialogId);
        let template: any = null;

        switch (automationNodeObj.type) {
            case RenderResponseType.AUTOMATION_START:
                template = this.getAutomationStartTemplate(automation, hostInstance);
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                    event: SDK_EVENTS.DIALOG_START_TEMPLATE,
                    data : automation
                });
                break;
    
            case RenderResponseType.AUTOMATION_END:
                this.appendFeedbackWrapper(dialogWrapper, automation, hostInstance);
                template = this.getAutomationEndTemplate(automation, hostInstance);
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                    event: SDK_EVENTS.DIALOG_END_TEMPLATE,
                    data : automation
                });
                break;
    
            case RenderResponseType.AUTOMATION_NODE:
                template = this.getAutomationNodeTemplate(automation, automationNodeObj, activeTab, hostInstance);
                break;
    
            case RenderResponseType.FEEDBACK:
                if(this.aaSettings?.feedback[FeebackConst.DIALOGS]?.isEnabled){
                    automation.feedbackData = automationNodeObj;
                    this.handleFeedbackType(automation, dialogWrapper, FeebackConst.DIALOGS, hostInstance);
                }
                return;
    
            default:
                return;
        }
    
        this.appendAutomationEachNodeTemplate(dialogWrapper, template, automationNodeObj, automation.dialogId);
    }
    
    getDialogWrapper(hostInstance: any, dialogId: string) {
        return hostInstance?.chatEle?.querySelector?.(`${this.classConstants.DIALOG_WRAPPER}${dialogId}`);
    }
    
    getAutomationStartTemplate(automation: any, hostInstance: any) {
        return getHTML(DialogStart, { dialog: automation }, hostInstance);
    }
    
    getAutomationEndTemplate(automation: any, hostInstance: any) {
        let feedbackEnable = this.aaSettings?.feedback[FeebackConst.DIALOGS]?.isEnabled ? true : false;
        return getHTML(DialogEnd, { dialog: automation, feedbackEnable }, hostInstance);
    }
    
    appendFeedbackWrapper(dialogWrapper: any, automation: any, hostInstance: any) {
        const feedbackWrapperTemplate = getHTML(FeedbackWrapperInsideDialog, { dialog: automation }, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, feedbackWrapperTemplate, {
            event: SDK_EVENTS.FEEDBACK_WRAPER_TEMPLATE,
            data : automation
        });
        dialogWrapper?.append(feedbackWrapperTemplate);
    }
    
    getAutomationNodeTemplate(automation : any, automationNodeObj: any, activeTab: string, hostInstance: any) {

        let template: any = null;
        
        switch (automationNodeObj.nodeType) {
            case RenderResponseType.ENTITY_NODE:
                let manualMode = this.manualAssistOverrideMode || !this.proactiveMode;                
                let payload : any = { entityNode: automationNodeObj, activeTab, manualMode, hostInstance }
                if(automationNodeObj.data.entityType != 'attachment'){
                    template = getHTML(AskCustomer, payload, hostInstance);
                }else{
                    automationNodeObj.fileObj = {};
                    if(activeTab == ProjConstants.ASSIST){
                        template = getHTML(AttachmentAskCustomer, payload, hostInstance);
                    }else{
                        template = getHTML(MybotAttachmentAskCustomer, payload, hostInstance);
                    }
                }
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                    event: SDK_EVENTS.ASK_CUSTOMER_TEMPLATE,
                    data : payload
                });
                this.appendTemplate(template,automationNodeObj);
                this.templateRenderCheck(template, automationNodeObj, hostInstance);
                this.handleEntityNodeClickEvents(template, automationNodeObj, activeTab, hostInstance);
                break;
    
            case RenderResponseType.MSG_NODE:
                template = getHTML(TellCustomer, { msgNode: automationNodeObj, hostInstance }, hostInstance);
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                    event: SDK_EVENTS.TELL_CUSTOMER_TEMPLATE,
                    data : automationNodeObj
                });
                this.appendTemplate(template,automationNodeObj);
                this.templateRenderCheck(template, automationNodeObj, hostInstance);
                break;
        }
    
        return template;
    }

    checkForGreyOut(template: any, automationNodeObj: any, hostInstance: any) {
        if(this.isHistory && typeof this.prefsOpacity === 'number'){
            template.style.opacity = (this.prefsOpacity/100).toString();
        }
    }

    templateRenderCheck(template: any, automationNodeObj: any, hostInstance: any) {
        if(automationNodeObj?.templateRender !== true){
            this.handleNodeResponse(automationNodeObj, template, hostInstance);
        }
        else{
            this.checkForGreyOut(template, automationNodeObj, hostInstance);
        }    
    }
    
    appendTemplate = (template : any, entityNode : any) => {
        this.appendTemplateToContainer(template, entityNode);
    }

    appendTemplateToContainer(template: HTMLElement | null, entityNode: any): void {
        try {
            // Validate inputs
            if (!template) {
                return;
            }
    
            if (!entityNode?.templateRender) {
                return;
            }
    
            if (!entityNode?.template) {
                return;
            }
    
            // Find container element
            const container = template.querySelector('.chat-container');
            if (!container) {
                console.error('Chat container element not found');
                return;
            }
    
            // Safely append template
            try {
                let timeStamp = entityNode?.template?.querySelector?.(`.top-info`);
                if(timeStamp){
                    timeStamp.remove();
                }
                container.append(entityNode.template);
            } catch (appendError) {
                console.error('Failed to append template to container:', appendError);
                // Optionally implement fallback behavior here
            }
    
        } catch (error) {
            console.error('Error in appendTemplateToContainer:', error);
            // Optionally implement error recovery or notification system
        }
    }

    handleErrorPrompts(automation : any, automationNodeObj : any, hostInstance : any) {
        let prevEnityNode : any = null;
        for(let i = automation?.automationNodes?.length - 1; i >= 0; i--){            
            prevEnityNode = automation.automationNodes[i]?.data?.isPrompt ? automation.automationNodes[i] : null;
            if(prevEnityNode){
                break;
            }
        }        
        if(prevEnityNode){ 
            let lastAutomationNodes = hostInstance?.chatEle?.querySelectorAll(`${this.classConstants.ASK_CUST_NODE}${prevEnityNode.uuid}`);
            lastAutomationNodes.forEach((lastAutomationEle : any) => {   
                let entityBody = lastAutomationEle?.querySelector(`${this.classConstants.ENTITY_MSG_BODY}`);
                if(prevEnityNode?.data?.isPrompt && automationNodeObj?.data?.isErrorPrompt){
                    automationNodeObj.errorCount = (prevEnityNode.errorCount || 0) + 1;
                    entityBody?.remove();         
                }else{
                    // remove error count from dialog
                    let automationEle = hostInstance?.chatEle?.querySelector(`${this.classConstants.DIALOG_WRAPPER}${automation.dialogId}`);
                    let errorMsgs = automationEle?.querySelectorAll(`.wrong-res-info`);
                    errorMsgs?.forEach((ele : any) => {
                        ele.remove();
                    });

                    // remove error count from listview
                    let listView = hostInstance?.chatEle?.querySelector(`${this.classConstants.LIST_VIEW_POPUP}`);
                    let listViewErrorMsgs = listView?.querySelectorAll(`.wrong-res-info`);
                    listViewErrorMsgs?.forEach((ele : any) => {
                        ele.remove();
                    });

                    entityBody?.classList?.remove('error-no-reponse');
                }

                if(lastAutomationEle && typeof this.prefsOpacity === 'number'){
                    lastAutomationEle.style.opacity = (this.prefsOpacity/100).toString();
                }
            });
            // let lastAutomationEle = hostInstance?.chatEle?.querySelector(`${this.classConstants.ASK_CUST_NODE}${prevEnityNode.uuid}`);  
        }
    }
    
    appendAutomationEachNodeTemplate(dialogWrapper: any, template: any, automationNodeObj: any, dialogId: string) {
        const feedbackWrapper = dialogWrapper?.querySelector?.(`${this.classConstants.FEEDBACK_WRAPPER}${dialogId}`);
        const feedbackHelpfulSection = dialogWrapper?.querySelector?.(`${this.classConstants.FEEDBACK_HELPFUL_SECTION}${dialogId}`);
    
        if (template && automationNodeObj.type !== RenderResponseType.AUTOMATION_END) {
            dialogWrapper?.append(template);
        } else if (template) {
            feedbackHelpfulSection?.append(template);
        }
    }
    // Automation template code ends
    

    //Entity node click events starts
    handleEntityNodeClickEvents(askCustTemplate: any, automationNodeObj: any, currentTab : string, hostInstance: any) {

        const inputEle = askCustTemplate.querySelector(`${this.classConstants.ENTITY_INPUT}`);
        const overrideBtn = askCustTemplate.querySelector(`${this.classConstants.ENTITY_OVERRIDE_BTN}`);
        const removeBtn = askCustTemplate.querySelector(`${this.classConstants.ENTITY_REMOVE_BTN}`);
        const checkBtn = askCustTemplate.querySelector(`${this.classConstants.ENTITY_CHECK_BTN}`);
        const agentIcon = askCustTemplate.querySelector(`${this.classConstants.ENTITY_AGENT_ICON}`);
        const errorTemplate = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_ERROR_OVERRIDE_TEXT}`);
        const chooseFileBtn = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_CHOOSE_FILE}`);

        if(!inputEle){
            return;
        }

        if(currentTab === ProjConstants.CUSTOM || currentTab === ProjConstants.MYBOT){
            agentIcon?.classList?.remove(this.classConstants.HIDE_ELEMENT);
        }
    
        if ((!this.proactiveMode || this.manualAssistOverrideMode) || (currentTab === ProjConstants.MYBOT || currentTab === ProjConstants.CUSTOM)) {
            inputEle.readOnly = false;
            inputEle.focus();
        }
    
        const onOverrideClick = (e: any) => this.handleOverrideClick(e, errorTemplate, inputEle, overrideBtn, askCustTemplate, removeBtn, checkBtn, automationNodeObj, hostInstance);
        const onRemoveClick = (e: any) => this.handleRemoveClick(e, errorTemplate, inputEle, overrideBtn, removeBtn, checkBtn, askCustTemplate, automationNodeObj, hostInstance);
        const onCheckClick = (e: any) => this.handleCheckClick(e, inputEle, automationNodeObj, askCustTemplate, hostInstance);
        const onInputKeydown = (e: any) => this.handleInputKeydown(e, inputEle, automationNodeObj, askCustTemplate, currentTab, hostInstance);
        const onInputChange = (e: any) => this.handleInputChange(e, inputEle, checkBtn);
        const onChooseFile = (e : any) => this.handleChooseFile(e, inputEle, askCustTemplate, automationNodeObj, currentTab,hostInstance);
        const onViewClick = (e : any) => this.handleViewClick(e, inputEle, askCustTemplate, automationNodeObj, hostInstance);
    
        hostInstance.eventManager?.addEventListener(`${this.classConstants.ENTITY_OVERRIDE_BTN}`, 'click', onOverrideClick, askCustTemplate);
        hostInstance.eventManager?.addEventListener(`${this.classConstants.ENTITY_REMOVE_BTN}`, 'click', onRemoveClick, askCustTemplate);
        hostInstance.eventManager?.addEventListener(`${this.classConstants.ENTITY_CHECK_BTN}`, 'click', onCheckClick, askCustTemplate);
        hostInstance.eventManager?.addEventListener(`${this.classConstants.ENTITY_INPUT}`, 'keydown', onInputKeydown, askCustTemplate);
        hostInstance.eventManager?.addEventListener(`${this.classConstants.ENTITY_INPUT}`, 'input', onInputChange, askCustTemplate);
        if(automationNodeObj?.data?.entityType === 'attachment'){
            hostInstance.eventManager?.addEventListener(`${this.classConstants.ENTITY_INPUT}`, 'change', onChooseFile, askCustTemplate);
            hostInstance.eventManager?.addEventListener(`${this.classConstants.ENTITY_ATTACHMENT_VIEW}`, 'click', onViewClick, askCustTemplate);

        }
    }

    handleViewClick(e : any, inputEle : any, askCustTemplate : any, automationNodeObj : any, hostIns : any){
        let viewModal = hostIns?.chatEle?.querySelector(`${this.classConstants.ENTITY_ATTACHMENT_VIEW_MODAL}`);
        viewModal?.classList?.remove(this.classConstants.HIDE_ELEMENT);
        let image = viewModal?.querySelector(`${this.classConstants.ENTITY_ATTACHMENT_IMAGE}`);
        image.src = automationNodeObj?.attachments[0]?.url?.fileUrl;
    }

    handleChooseFile(e : any, inputEle : any, askCustTemplate : any, automationNodeObj : any, currentTab : string, hostInstance : any){
        automationNodeObj.fileObj = e.target.files[0];
        let chooseFileText = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_CHOOSE_FILE}`);
        if(automationNodeObj?.fileObj?.name){
            chooseFileText.innerText = automationNodeObj?.fileObj?.name;
        }
        if((currentTab === ProjConstants.MYBOT || !this.proactiveMode || this.manualAssistOverrideMode) && automationNodeObj?.fileObj?.name){
            this.fileUploadCall(automationNodeObj, hostInstance);
        }
    }

    handleOverrideClick(e: any, errorTemplate: any, inputEle: any, overrideBtn : any, askCustTemplate: any, removeBtn: any, checkBtn: any, automationNodeObj: any, hostInstance: any) {
        if(inputEle){
            inputEle.readOnly = false;
            inputEle.placeholder = '';
            inputEle.focus();
            removeBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            checkBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            overrideBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);
            if (!this.OverRideMode) {
                hostInstance.handleOverrideMode(true, automationNodeObj.dialogId);
            }
            errorTemplate.innerText = '| Type to continue';
            if(!automationNodeObj?.errorCount){
                askCustTemplate?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_MSG}`)?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            }
            if(automationNodeObj?.data?.entityType === 'attachment'){
                this.toggleAttachmentDiv(automationNodeObj, askCustTemplate, inputEle, true);
            }

        }
        
    }
    
    handleRemoveClick(e: any, errorTemplate : any, inputEle: any, overrideBtn: any, removeBtn: any, checkBtn: any, askCustTemplate : any, automationNodeObj : any, hostInstance : any) {
        inputEle.readOnly = true;
        overrideBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
        removeBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);
        checkBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);
        inputEle.placeholder = 'waiting...';
        inputEle.value = '';
        errorTemplate.innerText = '';
        if(!automationNodeObj?.errorCount){
            askCustTemplate?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_MSG}`)?.classList?.add(this.classConstants.HIDE_ELEMENT)
        }
        if(automationNodeObj?.data?.entityType === 'attachment'){
            this.toggleAttachmentDiv(automationNodeObj, askCustTemplate,inputEle, false);
            this.addorRemoveAttachemntFileError(automationNodeObj,hostInstance, true)
        }
    }
    
    handleCheckClick(e: any, inputEle: any, automationNodeObj: any, askCustTemplate: any, hostInstance: any,) {
        if(automationNodeObj?.data?.entityType === 'attachment'){
            if(automationNodeObj.fileObj && automationNodeObj.fileObj.name) {
                this.fileUploadCall(automationNodeObj, hostInstance);
            }
        }else {
            const sanitizedValue = this.sanitizeHTML(inputEle.value);
            inputEle.value = sanitizedValue;
            if(inputEle?.value){
                this.assistInputValue(inputEle.value, automationNodeObj, hostInstance);
                this.showAgentIcon(automationNodeObj, hostInstance);
            }
        }
    }
    
    handleInputKeydown(e: any, inputEle: any, automationNodeObj: any, askCustTemplate: any, currentTab : string,  hostInstance: any,) {
        const sanitizedValue = this.sanitizeHTML(inputEle?.value);
        inputEle.value = sanitizedValue;
        if (e.key === 'Enter' && inputEle?.value) {
            if(currentTab === ProjConstants.ASSIST){
                this.assistInputValue(inputEle.value, automationNodeObj, hostInstance);
                this.showAgentIcon(automationNodeObj, hostInstance);
            }else if(currentTab === ProjConstants.MYBOT){
                this.mybotInputValue(inputEle.value, automationNodeObj, hostInstance);
                inputEle.setAttribute('data-inputValue', inputEle?.value);
                const scrollDims = safeScrollDimensions(inputEle);
                if(scrollDims.scrollHeight >= 60){
                    this.hideMoreTextInEntityNode(inputEle, hostInstance, scrollDims.scrollHeight);
                }
                this.showAgentIcon(automationNodeObj, hostInstance);
            }else if(currentTab === ProjConstants.CUSTOM){
                this.customInputValue(inputEle.value, automationNodeObj, hostInstance);
                inputEle.setAttribute('data-inputValue', inputEle?.value);
                const scrollDims = safeScrollDimensions(inputEle);
                if(scrollDims.scrollHeight >= 60){
                    this.hideMoreTextInEntityNode(inputEle, hostInstance, scrollDims.scrollHeight);
                }
                this.showAgentIcon(automationNodeObj, hostInstance);
            }
        }
    }


    customInputValue(inputValue: any, automationNodeObj: any, hostInstance: any) {
        this.addLoaderForAutomation(automationNodeObj, hostInstance);
        let connectionDetails = Object.assign({}, this.connectionDetails);
        connectionDetails.value = inputValue;
        connectionDetails.isSearch = false;
        connectionDetails.positionId = automationNodeObj.dialogId;
        connectionDetails.childBotId = automationNodeObj.data.childBotId;
        connectionDetails.childBotName = automationNodeObj.data.childBotName;
        connectionDetails.sourceMsgId = automationNodeObj.sourceMsgId || '';
        if(automationNodeObj?.data?.entityType === 'attachment') {
            let fileObj = automationNodeObj?.fileObj;
          connectionDetails.attachments = [
            {
                "fileName": fileObj?.name || '',
                "fileType": fileObj?.type,
                "fileId": fileObj.fileId || '',
                "url": {
                    "fileUrl": fileObj.fileURL || ''
                }
            }
          ]
        }
        let agent_assist_custom_request_params = hostInstance.prepareAgentAssistCustomRequestParams(connectionDetails);
        hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_custom_request, agent_assist_custom_request_params);    
    }
    
    handleInputChange(e: any, inputEle: any, checkBtn: any) {
        if (inputEle?.value) {
            this.AutoExpandTextarea(inputEle);
            checkBtn?.classList?.remove(this.classConstants.AGENTASSIST_DISABLED_MSG);
        } else {
            
            checkBtn?.classList?.add(this.classConstants.AGENTASSIST_DISABLED_MSG);
        }
    }

    
    AutoExpandTextarea(inputEle: any) {
        if(inputEle?.value){
            inputEle.style.height = 'auto';
            const scrollDims = safeScrollDimensions(inputEle);
            inputEle.style.height = Math.min(scrollDims.scrollHeight, 60) + 'px';
        }             
    }

    showAttachmentView(automationNodeObj: any, askCustTemplate : any, inputEle : any){
        let viewBtn = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_ATTACHMENT_VIEW}`);
        let attachments = automationNodeObj?.attachments?.[0];
        let overrideBtn = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_BTN}`);
        inputEle.readOnly = true;
        if(attachments?.url?.fileUrl && (attachments?.fileType == 'image/png' || attachments?.fileType == 'image')){
            viewBtn?.classList.remove(this.classConstants.HIDE_ELEMENT);
            overrideBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }
    }

    toggleAttachmentDiv (automationNodeObj: any, askCustTemplate : any, inputEle : any, flag : boolean){
        let attachmentDiv =  askCustTemplate?.querySelector(`${this.classConstants.ENTITY_ATTACHMENT_DIV}`);
        let entityDisplay = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_DISPLAY_NAME}`);
        let chooseFileText = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_CHOOSE_FILE}`);
        
        if(attachmentDiv){
            if(flag){
                attachmentDiv?.classList?.remove(this.classConstants.HIDE_ELEMENT);
                entityDisplay?.classList?.add(this.classConstants.HIDE_ELEMENT);
                inputEle.type = 'file';
                inputEle?.classList?.add(this.classConstants.INPUT_ATTACHMENT);
            }else{
                attachmentDiv?.classList?.add(this.classConstants.HIDE_ELEMENT);
                entityDisplay?.classList?.remove(this.classConstants.HIDE_ELEMENT);
                inputEle.type = 'text';
                inputEle?.classList?.remove(this.classConstants.INPUT_ATTACHMENT);
            }
            // let textContent = automationNodeObj.data.entityValue ? automationNodeObj.data.entityValue : 'Choose File';
            // chooseFileText.innerText = textContent;
        }
    }

    assistInputValue(inputValue: any, automationNodeObj: any, hostInstance: any) {
        this.addLoaderForAutomation(automationNodeObj, hostInstance);
        let connectionDetails = Object.assign({}, this.connectionDetails);
        connectionDetails.value = inputValue;
        connectionDetails.positionId = automationNodeObj.dialogId;
        connectionDetails.childBotId = automationNodeObj.data.childBotId;
        connectionDetails.childBotName = automationNodeObj.data.childBotName;
        connectionDetails.sourceMsgId = automationNodeObj.sourceMsgId || '';
        if(automationNodeObj?.data?.entityType === 'attachment' && this.activeTab === Tabs.ASSIST) {
            let fileObj = automationNodeObj?.fileObj;
          connectionDetails.attachments = [
            {
                "fileName": fileObj?.name || '',
                "fileType": fileObj?.type,
                "fileId": fileObj.fileId || '',
                "url": {
                    "fileUrl": fileObj.fileURL || ''
                }
            }
          ]
        }
        let assistRequestParams = hostInstance.prepareAgentAssistRequestParams(connectionDetails);
        hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_request, assistRequestParams);
    }



    mybotInputValue(inputValue: any, automationNodeObj: any, hostInstance: any) {
        this.addLoaderForAutomation(automationNodeObj, hostInstance);
        let connectionDetails = Object.assign({}, this.connectionDetails);
        connectionDetails.value = inputValue;
        connectionDetails.isSearch = false;
        connectionDetails.positionId = automationNodeObj.dialogId;
        connectionDetails.childBotId = automationNodeObj.data.childBotId;
        connectionDetails.childBotName = automationNodeObj.data.childBotName;
        connectionDetails.sourceMsgId = automationNodeObj.sourceMsgId || '';
        if(automationNodeObj?.data?.entityType === 'attachment') {
            let fileObj = automationNodeObj?.fileObj;
          connectionDetails.attachments = [
            {
                "fileName": fileObj?.name || '',
                "fileType": fileObj?.type,
                "fileId": fileObj.fileId || '',
                "url": {
                    "fileUrl": fileObj.fileURL || ''
                }
            }
          ]
        }
        let agent_assist_agent_request_params = hostInstance.prepareAgentAssistAgentRequestParams(connectionDetails);
        hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_agent_request, agent_assist_agent_request_params);
    }

    handleEntityInput(node : any, hostInstance: any, disabled = false) { 
        const entityNodes =  hostInstance.chatEle?.querySelectorAll(`${this.classConstants.ASK_CUST_NODE}${node.uuid}`);
        entityNodes.forEach((askCustTemplate : any) => {            
            let actionButtons: any = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_ACTIONS}`);        
            actionButtons?.childNodes?.forEach((btn: any) => {
                let agentIconBtn = btn?.classList?.contains(`aa-entity-agent-icon`);
                let errorBtn = btn?.classList?.contains(`aa-entity-error-btn`);
                let viewBtn = btn?.classList?.contains(`aa-entity-attachment-view`);
                if(btn && !agentIconBtn && (!errorBtn || disabled) && !viewBtn){
                    btn?.classList?.add(this.classConstants.HIDE_ELEMENT);
                }
            });
            askCustTemplate?.querySelector(`${this.classConstants.ENTITY_ERROR_MESSAGE}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
            askCustTemplate?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_MSG}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
        });
    }

    showAgentIcon (node : any, hostInstance : any){
        const entityNodes =  hostInstance.chatEle?.querySelectorAll(`${this.classConstants.ASK_CUST_NODE}${node.uuid}`);
        entityNodes.forEach((askCustTemplate : any) => { 
            const inputEle = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_INPUT}`);
            inputEle.readOnly = true;       
            let actionButtons: any = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_ACTIONS}`);        
            actionButtons?.childNodes?.forEach((btn: any) => {
                let agentIconPresent = btn?.classList?.contains(`aa-entity-agent-icon`);
                if(btn && agentIconPresent){
                    btn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
                }else if(btn){
                    btn?.classList?.add(this.classConstants.HIDE_ELEMENT);
                }
            });
            askCustTemplate?.querySelector(`${this.classConstants.ENTITY_ERROR_MESSAGE}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
            askCustTemplate?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_MSG}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
        });
    }

    showEntityNodeInputButtons(askCustTemplate: any){
        let actionButtons: any = askCustTemplate?.querySelector(`${this.classConstants.ENTITY_ACTIONS}`);        
        actionButtons.childNodes?.forEach((btn: any) => {            
            if(btn?.classList.contains('aa-entity-override-btn')){                
                btn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            }else{
                btn?.classList?.add(this.classConstants.HIDE_ELEMENT);
            }
        });
    }
    //Entity node click events ends

    //Process UserMessages for smalltalk and automation starts
    processUserMessages(
        userResponse: any,
        lastObj: any,
        templateClick: boolean,
        getNode: (lastObj: any) => any,
        hostInstance: any
    ) {
        const node = getNode(lastObj);
 
        if (node?.data?.isPrompt) {

            let fileName = '';
            
            if(node?.type === RenderResponseType.AUTOMATION_NODE){
                if( node?.data?.entityType === 'attachment'){
                    
                    if(userResponse?.attachments?.length > 0){
                        fileName = userResponse?.attachments[0]?.fileName;
                    }

                    if(userResponse?.entities && Array.isArray(userResponse.entities[userResponse.entityName]) &&  userResponse?.entities[userResponse?.entityName][0]?.fileId){                        
                        node.attachments = userResponse?.entities[userResponse?.entityName];
                        fileName = !fileName ? userResponse?.entities[userResponse?.entityName][0]?.fileName : fileName;
                    }
                }   
            }

            node.data.entityValue = fileName ? fileName : userResponse?.entityValue || userResponse.userInput;

            const entityNodes = hostInstance?.chatEle?.querySelectorAll(
                `${this.classConstants.ASK_CUST_NODE}${node.uuid}`
            );
 
            entityNodes.forEach((askCustNode : any) => {
                const inputEle = askCustNode?.querySelector(
                    `${this.classConstants.ENTITY_INPUT}`
                );

                if(node?.data?.entityType === 'attachment'){
                    
                    this.toggleAttachmentDiv(node, askCustNode,inputEle, false);
                    this.showAttachmentView(node, askCustNode, inputEle);
                }
    
                if (inputEle) {
                    inputEle.value = node.data.entityValue;
                }
    
                const scrollDims = safeScrollDimensions(inputEle);
                if(inputEle && scrollDims.scrollHeight >= 60){
                    inputEle.style.height = 'auto';
                    inputEle.style.height = 18 + 'px';
                }

                if(templateClick){
                    askCustNode?.querySelector(`${this.classConstants.ENTITY_AGENT_ICON}`)?.classList?.remove(this.classConstants.HIDE_ELEMENT);
                }
            });
            this.handleEntityInput(node, hostInstance);
        }
        return lastObj;
    };

    hideMoreTextInEntityNode(inputEle: any, hostInstance: any, scrollHeight: number){
        inputEle.style.height = 'auto';
        inputEle.style.height = 30 + 'px';


        const expandBtn = inputEle?.parentElement?.querySelector(`${this.classConstants.ENTITY_EXPAND_BTN}`);
        const reduceBtn = inputEle?.parentElement?.querySelector(`${this.classConstants.ENTITY_REDUCE_BTN}`);
        const inputValue = inputEle?.value;

        if(inputValue){
            inputEle.value = inputValue?.slice(0, 40) + '...';
        }


        if(!expandBtn){
            const expandBtn:any = getHTML(ExpandButtonForEntity, {} , hostInstance);
            hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, expandBtn, { event: SDK_EVENTS.ENTITY_EXPAND_BTN, data: { inputEle: inputEle } });
            expandBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            inputEle?.parentElement?.appendChild(expandBtn);  
        }
        else if(expandBtn && reduceBtn){
            expandBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            reduceBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);   
            return; 
        }
        else{
            expandBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            return;
        }
        
        inputEle?.parentElement?.querySelector(`${this.classConstants.ENTITY_EXPAND_BTN}`)?.addEventListener('click', (e: any) => {
            e.stopPropagation();
            this.showMoreTextInEntityNode(inputEle, hostInstance, scrollHeight, inputValue);
        });
    }

    showMoreTextInEntityNode(inputEle: any, hostInstance: any, scrollHeight: number, inputValue: string | number, isListView = false){

        const expandBtn = inputEle?.parentElement?.querySelector(`${this.classConstants.ENTITY_EXPAND_BTN}`);
        const reduceBtn = inputEle?.parentElement?.querySelector(`${this.classConstants.ENTITY_REDUCE_BTN}`);

        

        if(isListView){
            inputEle.style.height = 'auto';
            inputEle.style.height = 60 + 'px';            
        }
        else{
            inputEle.style.height = 'auto';
            inputEle.style.height = Math.min(scrollHeight, 60) + 'px';
        }

        if(inputValue){
            inputEle.value = inputValue;
        }

        if(!reduceBtn){
            const reduceBtnHtml:any = getHTML(ReduceButtonForEntity, {}, hostInstance);
            hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, reduceBtnHtml, { event: SDK_EVENTS.ENTITY_REDUCE_BTN, data: { inputEle: inputEle } });
            reduceBtnHtml?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            expandBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);
            inputEle?.parentElement?.appendChild(reduceBtnHtml);
        }
        else if(reduceBtn && expandBtn){
            reduceBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
            expandBtn?.classList?.add(this.classConstants.HIDE_ELEMENT);
        }
        else{
            reduceBtn?.classList?.remove(this.classConstants.HIDE_ELEMENT);
        }

        inputEle?.parentElement?.querySelector(`${this.classConstants.ENTITY_REDUCE_BTN}`)?.addEventListener('click', (e: any) => {
            e.stopPropagation();
            this.hideMoreTextInEntityNode(inputEle,hostInstance, scrollHeight);
        });
    }

    

    processUserMessagesForSmallTalk(userResponse: any, lastObj: any, templateClick: boolean, hostInstance: any) {
        return this.processUserMessages(userResponse, lastObj, templateClick, (lastObj) => lastObj, hostInstance);
    };

    processUserMessagesForAutomation(userResponse: any, lastObj: any, templateClick: boolean, hostInstance: any) {
        return this.processUserMessages(userResponse, lastObj, templateClick, (lastObj) =>
            lastObj?.automationNodes[lastObj.automationNodes?.length - 1], hostInstance);
    };
     //Process UserMessages for smalltalk and automation ends


    getTemplateHtml(isTemplateRender: boolean, result: any, hostInstance: any) {  
        return ErrorHandler.wrapExternalCall(() => {
            if (!isTemplateRender) return null;
            if (!hostInstance?.chatWindowInstance?.generateMessageDOM) {
                console.warn('generateMessageDOM not available');
                return null;
            }
            return hostInstance.chatWindowInstance.generateMessageDOM(result);
        }, null);    
    }


  handleTemplateClickEvents(value : any, activeTab : string, positionId : string, hostInstance : any) {
    let connectionObj = this.connectionDetails;
    let requestParams : any = {
        "conversationId": connectionObj.conversationId,
        "query": value,
        "botId": connectionObj.botId,
        "experience": connectionObj?.channel,
        "autoBotId": connectionObj.autoBotId,
        "positionId" : positionId
    }
      if (activeTab == Tabs.ASSIST) {
        requestParams.entities = [];
        requestParams.check = true;
        requestParams.intType = "assist"
        hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_request, requestParams);
        // this.rootService.setAssistTemplateClick(true);
      } else if (activeTab == Tabs.MYBOT) {
        requestParams.isSearch = false;
        requestParams.intType = "myBot";
        hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_agent_request, requestParams);
        // this.rootService.setMyBotTemplateClick(true);
      } else if (activeTab == Tabs.CUSTOM_TAB) {
        requestParams.intType = "custom";
        requestParams.crId = "custom";
        hostInstance.socketConnection.emitEvents(EVENTS.agent_assist_custom_request, requestParams);
      }
    }

    closeListView (hostInstance : any) {
        hostInstance?.chatEle?.querySelector?.(`${this.classConstants.LIST_VIEW_POPUP}`).classList?.add(this.classConstants.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelector(`${this.classConstants.LIST_VIEW_POPUP}`)?.querySelectorAll(`${this.classConstants.ENTITY_NODE}`)?.forEach((ele: any) => {
            ele.remove();
        });
    }

    addorRemoveAttachemntFileError(automationNodeObj : any, hostInstance : any, hide = false){
        if(automationNodeObj?.data.entityType === 'attachment'){
            const entityNodes = hostInstance?.chatEle?.querySelectorAll(
                `${this.classConstants.ASK_CUST_NODE}${automationNodeObj.uuid}`
            );
            
            entityNodes.forEach((askCustNode : any) => {
                let attachmentError = askCustNode?.querySelector(`${this.classConstants.ENTITY_ATTACHMENT_LARGE_FILE_MSG}`);
                let overrideMsg = askCustNode?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_MSG}`);
                if(automationNodeObj?.fileObj?.largeFileFlag && !hide){
                    attachmentError?.classList?.remove(this.classConstants.HIDE_ELEMENT);
                    overrideMsg?.classList?.add(this.classConstants.HIDE_ELEMENT);
                }else{
                    attachmentError?.classList?.add(this.classConstants.HIDE_ELEMENT);
                }
            });
        }
    }

   

    //attachment file upload
    fileUploadCall(automationNodeObj : any, hostIns : any) {
        let file = automationNodeObj?.fileObj;
        let uploadInprogress = false;
        if (!file) {
            return;
        }

        automationNodeObj.fileObj.largeFileFlag = false;
      
        // Restrict file size to 25MB
        if (file.size >= 25000000) {
            automationNodeObj.fileObj.largeFileFlag = true;
            this.addorRemoveAttachemntFileError(automationNodeObj, hostIns);
          return;
        }
      
        const reader = new FileReader();
        reader.readAsText(file);
        
        
        reader.onload = function (e) {
          // handle file read if needed
        };
      
        const CHUNK_SIZE = 1024 * 1024 * 2; // Adjust chunk size (5MB for example)
        
        let chunkUpload = file.size > CHUNK_SIZE;
      
        if (chunkUpload) {
          // Simulate chunk file token retrieval (using Promises instead of Observable)
          hostIns.chunkFileUploadService.getFileToken().then((token : any) => {
            if (token) {
              hostIns.chunkFileUploadService.uploadChunkFile(token, file).then((fileId : any) => {
                console.log("fileId received>>>>>>>", fileId);
                if (fileId) {
                  this.getuploadedFileURL(automationNodeObj,fileId, hostIns);
                }
              }).catch((err : any) => console.error("Error during chunk upload", err));
            }
          }).catch((err : any) => console.error("Error retrieving file token", err));
        } else {
          const reader = new FileReader();
          reader.readAsDataURL(file);
      
          const formData = new FormData();
          
          formData.append('file', file);
          formData.append('fileContext', 'bulkImport');
          formData.append('fileExtension', file.name.substring(file.name.lastIndexOf('.') + 1));
          formData.append('Content-Type', file.type);
          formData.append('fileName', file.name);
      
          uploadInprogress = true;
      
          // Simulate file upload using fetch instead of Angular's serviceInvoker

            fetchInstance('post_uploadfile', {
                method: 'POST',
                body : formData,
                },
                hostIns, {})
                .then(res => {
                    automationNodeObj.fileObj.largeFileFlag = false;
                    automationNodeObj.fileObj.fileId = res.fileId;
                    this.getuploadedFileURL(automationNodeObj, res.fileId, hostIns);
                    this.addorRemoveAttachemntFileError(automationNodeObj, hostIns);
                }).catch(err => console.error("Error during file upload", err));
        }
    }
 
      
    getuploadedFileURL(automationNodeObj : any, fileId : any, hostIns : any) {
        // Further logic to handle the uploaded file URL

        fetchInstance('get_uploadedfile', {
            method: 'GET'
          },  hostIns, {fileId}).then((res) => {
                automationNodeObj.fileObj.fileURL = res?.fileUrl;
                if(this.activeTab === Tabs.ASSIST){
                    this.assistInputValue(automationNodeObj.fileObj.name, automationNodeObj, hostIns);
                }else{
                    this.mybotInputValue(automationNodeObj.fileObj.name, automationNodeObj, hostIns);
                }
          }, (error) => {

          })
    }
      

    scrollToTop(element: any, tab : string, hostInstance : any) {
        element?.scroll({
            top: 0,
            behavior: 'smooth'
        });
        hostInstance.socketConnection.sendScrollEvent("scrollup_clicked", tab);
    }

    scrollToTillBottom(element: any, tab : string, hostInstance : any): void {
        if (element) {
            const scrollDims = safeScrollDimensions(element);
            element.scroll({
                top: scrollDims.scrollHeight,
                behavior: 'smooth'
            });
        }
        hostInstance.socketConnection.sendScrollEvent("scrolldown_clicked", tab);
    }   

    handleAssistScroll(hostInstance : any) {
        setTimeout(() => {
            const assistEle = hostInstance?.chatEle?.querySelector(this.classConstants.ASSIST_SECTION) as HTMLElement;
            if(this?.autoScrollStatus && assistEle){
                const scrollDims = safeScrollDimensions(assistEle);
                assistEle.scrollTop = scrollDims.scrollHeight;
            }
        }, 0);
    };

    handleMybotScroll(hostInstance : any) {
        const mybotEle = hostInstance?.chatEle?.querySelector(this.classConstants.MYBOT_SECTION) as HTMLElement;
        if(this?.autoScrollStatus && mybotEle){
            mybotEle.scrollTop = mybotEle.scrollHeight;
        }
    };

    handleCustomTabScroll(hostInstance : any) {
        const customTabEle = hostInstance?.chatEle?.querySelector(this.classConstants.CUSTOM_TAB_SECTION) as HTMLElement;
        if(this?.autoScrollStatus && customTabEle){
            customTabEle.scrollTop = customTabEle.scrollHeight;
        }
    }


    scrollBottomTranscript(hostInstance : any){
        setTimeout(() => {
            const transcriptEle = hostInstance?.chatEle?.querySelector(`.${this.classConstants.TRANSCRIPT_WRAPPER}`) as HTMLElement;
            if(this?.autoScrollStatus && transcriptEle){
                transcriptEle.scrollTop = transcriptEle.scrollHeight;
            }
        }, 0);
    }

    
    hideNetworkToastr(hostInstance: any) {
    document.querySelector(`.${hostInstance.config?.container}`)?.querySelector(`.${this.classConstants.NETWORK_ERROR_TOASTR}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
    }

    showNetworkToastr(hostInstance: any) {
    document.querySelector(`.${hostInstance.config?.container}`)?.querySelector(`.${this.classConstants.NETWORK_ERROR_TOASTR}`)?.classList?.remove(this.classConstants.HIDE_ELEMENT);
    }

    addLoaderForAutomation(automationNodeObj : any, hostInstance : any){
        let automationNode = hostInstance?.chatEle?.querySelector(`${this.classConstants.ASK_CUST_NODE}${automationNodeObj.uuid} .input-block-entity`);
        hostInstance.renderIndividualLoader(automationNode);
    }
    
    removeLoaderForAutomation(hostInstance : any, parentNode : any){
        hostInstance.removeIndividualLoader(parentNode);
    }

    //history api

    getWidgetFeedbackHistory(params: any, hostInstance: any) {
        return fetchInstance('get_feedback', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'botId': params.botId
            }
        }, hostInstance, {
            conversationId: params.conversationId,
            tab: 'widget'
        });
    }

    getAssistHistory(params: any, hostInstance: any) {
        const botId = hostInstance.rootService.connectionDetails.botId;

        return fetchInstance('post_assist_history', {
            method: 'POST',
            // body : JSON.stringify({limit : -1}),
            headers: {
                'Content-Type': 'application/json',
                // 'botId': botId,
                // 'excludeAccountId': true
            }
        }, hostInstance, {
            botId,
            convId: params.conversationId,
        });
    }

    getAssistFeedback(params: any, hostInstance: any) {
        return fetchInstance('get_feedback', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'botId': params.botId
            }
        }, hostInstance, {
            tab: 'assist',
            conversationId: params.conversationId
        });
    }

    getMybotHistory(params: any, hostInstance: any) {
        const botId = hostInstance.rootService.connectionDetails.botId;

        return fetchInstance('post_mybot_history', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // 'botId': botId,
                // 'excludeAccountId': true
            }
        }, hostInstance, {
            botId,
            convId: params.conversationId
        });
    }

    getMybotFeedback(params: any, hostInstance: any) {
        return fetchInstance('get_feedback', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'botId': params.botId
            }
        }, hostInstance, {
            tab: 'mybot',
            conversationId: params.conversationId
        });
    }

    getCustomTabFeedback(params:any , hostInstance:any){
        return fetchInstance('get_feedback', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'botId': params.botId
            }
        }, hostInstance, {
            tab: 'custom',
            conversationId: params.conversationId
        });
    }

    formatHistoryResponseToNormalRender(res : any, feedbackData : any, isAssist = true){
        let result : any = {};
        result = Object.assign({}, res.agentAssistDetails);
        result.type = res.type;
        result.buttons = [];
        result.intentName = res?.agentAssistDetails?.rootTN || res?.tN;
        result._id = res._id;
        result.entityDisplayName = result.newEntityDisplayName ? result.newEntityDisplayName : result.newEntityName;
        result.entityType = result?.newEntityType ? result?.newEntityType : '';
        result.expectedFormat = result.entityType || result.newEntityType;

        if(result.entities && result?.entities?.[result?.entityName]?.length > 0){
            result.attachments = result.entities[result?.entityName];
        }
        res?.components?.forEach((element : any) => {
            let value = element?.data?.text;
            result.buttons.push({value, type : element?.cT});
        });

        if (isAssist){

            if(result?.suggestions?.faqs?.length > 0){
                result.suggestions.faqs[0].answer = [res?.components[0]?.data?.text];
            }
    
            if(result?.ambiguityList && Object.keys(result?.ambiguityList)?.length > 0){
                result.suggestions = result.ambiguityList;
            }        

            result?.suggestions?.faqs?.forEach((faq : any) => {
                let feedbackObj = (feedbackData || [])?.find((feedback : any) => feedback.positionId === faq.positionId);
                faq.historyFeedback = feedbackObj;
            });
        }

        return result;
    }

    handlePreviousAutomationNode(entityNode: any, automationNodeObj: any, templateClick: boolean, hostInstance: any) {
        automationNodeObj.expectedFormat = automationNodeObj.entityType;
        if (entityNode?.nodeType === RenderResponseType.ENTITY_NODE) {

            const entityNodes = hostInstance?.chatEle?.querySelectorAll(
                `${this.classConstants.ASK_CUST_NODE}${entityNode.uuid}`
            );

            entityNodes.forEach((askCustNode: any) => {
                const inputEle = askCustNode?.querySelector(
                    `${this.classConstants.ENTITY_INPUT}`
                );

                let fileName = '';

                if(entityNode?.data?.entityType === 'attachment'){
                    entityNode.attachments = automationNodeObj.attachments;
                    automationNodeObj.attachments = null;
                    this.toggleAttachmentDiv(entityNode, askCustNode,inputEle, false);
                    this.showAttachmentView(entityNode, askCustNode, inputEle);
                    fileName = entityNode?.attachments?.[0]?.fileName;

                }

                if (inputEle && !inputEle.value) {
                    inputEle.value = fileName ? fileName: (automationNodeObj?.entityValue || automationNodeObj?.userInput || '');
                    if(!automationNodeObj?.isErrorPrompt){
                        askCustNode?.querySelector(`${this.classConstants.ENTITY_ERROR_MESSAGE}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
                        askCustNode?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_MSG}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
                    }
                    if(templateClick){
                        askCustNode?.querySelector(`${this.classConstants.ENTITY_AGENT_ICON}`)?.classList?.remove(this.classConstants.HIDE_ELEMENT);
                    }
                }
            });
        }
    }

    handleHistoryPreviousAutomationNode(entityNode: any, automationNodeObj: any, hostInstance: any) {
        automationNodeObj.expectedFormat = automationNodeObj.entityType;
        if (entityNode?.nodeType === RenderResponseType.ENTITY_NODE) {

            const entityNodes = hostInstance?.chatEle?.querySelectorAll(
                `${this.classConstants.ASK_CUST_NODE}${entityNode.uuid}`
            );

            entityNodes.forEach((askCustNode: any) => {
                const inputEle = askCustNode?.querySelector(
                    `${this.classConstants.ENTITY_INPUT}`
                );

                let fileName = '';

                if(entityNode?.data?.entityType === 'attachment'){
                    entityNode.attachments = automationNodeObj.attachments;
                    automationNodeObj.attachments = null;
                    this.toggleAttachmentDiv(entityNode, askCustNode,inputEle, false);
                    this.showAttachmentView(entityNode, askCustNode, inputEle);
                    fileName = entityNode?.attachments?.[0]?.fileName;
                }
                if (inputEle && !inputEle.value) {
                    inputEle.value = fileName ? fileName: (automationNodeObj?.userInput || automationNodeObj?.entityValue || '');



                    let height = this.getHiddenHeight(inputEle,inputEle?.parentElement);

                    inputEle.setAttribute('data-inputValue', inputEle?.value);

                    if(height >= 60){
                        inputEle.style.height = 'auto';
                        inputEle.style.height = Math.max(height, 60) + 'px';
                        this.hideMoreTextInEntityNode(inputEle, hostInstance, height);
                    }

                    if(!automationNodeObj?.isErrorPrompt){
                        askCustNode?.querySelector(`${this.classConstants.ENTITY_ERROR_MESSAGE}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
                        askCustNode?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_MSG}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
                        askCustNode?.querySelector(`${this.classConstants.ENTITY_OVERRIDE_BTN}`)?.classList?.add(this.classConstants.HIDE_ELEMENT);
                    }
                }
            });

        }
    }

    checkTransferDetailsAndDisableWidget = (hostInstance : any) => {
        setTimeout(() => {
            let appState = hostInstance?.localStorageService?.getConvObjFromLS();
            
            if(appState){
              let internalTransferDetails = appState[storageConst.INTERNAL_TRANSFER];
              if(internalTransferDetails){
                hostInstance.disableWidget(internalTransferDetails.isDisabled);
              }
            }
        });
    }

    getHiddenHeight(inputEle: any,parentEle: any) {
        const hiddenInput = document.createElement('textarea');
        hiddenInput.style.position = 'absolute';
        hiddenInput.style.visibility = 'hidden';
        hiddenInput.style.fontSize = '12px';
        hiddenInput.style.fontFamily = 'inherit';
        hiddenInput.style.fontWeight = '400';
        hiddenInput.style.lineHeight = '18px';
        hiddenInput.style.padding = '0';
        hiddenInput.style.border = '0';
        hiddenInput.style.opacity = '0';
        hiddenInput.style.overflow = 'hidden';
        hiddenInput.textContent = inputEle.value;
        hiddenInput.style.width = '400px';
        document.body.appendChild(hiddenInput);
        const height = hiddenInput.scrollHeight;
        document.body.removeChild(hiddenInput);
        return height;
    }

    findTaskInStringAndMake(prefsData:any,dialogPos:any,replacement:any){
        const stDialog = prefsData?.sg?.dT?.tL[dialogPos]?.msg;
        const regex = /\{\{task\}\}/gi;     
        const dialogSplit = stDialog.split(regex);
        if(dialogSplit.length==2){
            return {
                firstSt: dialogSplit[0].trim(),
                lastSt: dialogSplit[1].trim(),
                replaceSt: replacement
            }
        }
        else{
            return {
                firstSt: stDialog,
                lastSt: '',
                replaceSt: ''
            }
        }
            
    }


    checkDialogGroupingAndMake = (hostInstance:any,suggestionArr:any,prefsData:any) =>{
        if(prefsData.length === 0){
            return suggestionArr
        }
        const botId = hostInstance?.config?.connectionDetails?.botId;
        const isE = prefsData[botId]?.grpConfig?.isE
        const dialogGrp = prefsData[botId]?.grpConfig?.dgGrps;
        if(isE && dialogGrp[0].gn === '_default' && dialogGrp.length===1){
            this.isGroups = false
            return this.defaultGroupMake(dialogGrp[0].dlgs,suggestionArr)
        }
        else if(isE && dialogGrp.length>=1){
            this.isGroups = true
            return this.groupsMake(dialogGrp,suggestionArr)
        }
        return suggestionArr  

    }


    defaultGroupMake(dialogs:any,suggestionArr:any){
        if(dialogs.length === 0){
            return suggestionArr
        }
        let newSuggestionArr:Array<[]> = [];
        let hashMapSuggestionArr:any = {};
        for(let index=0;index<suggestionArr.length;index++){
            hashMapSuggestionArr[suggestionArr[index]?.taskRefId] = index
        }

        for(let dialog of dialogs){
            if(hashMapSuggestionArr.hasOwnProperty(dialog)){
                newSuggestionArr.push(suggestionArr[hashMapSuggestionArr[dialog]])
            }           
        }
        return newSuggestionArr
    }


    groupsMake = (dialogGroups:any,suggestionArr:any) => {
        let dialogGroupArr:Array<[]> = [];
        let hashMapSuggestionArr:any = {};

        for(let index=0;index<suggestionArr.length;index++){
            hashMapSuggestionArr[suggestionArr[index]?.taskRefId] = index
        }

        for(let grpObj of dialogGroups){
            const grpObjGroupName = grpObj?.gn;
            const grpObjGroupDialogArr = grpObj?.dlgs
            let dialogArrItems:Array<[]> = []

            let dialogGroupArrItem:any = {
                "gn": grpObjGroupName,
                "isExpanded": grpObj?.isExpanded || false
            }
            
            for(let dialogIds of grpObjGroupDialogArr){
                if(hashMapSuggestionArr.hasOwnProperty(dialogIds)){
                    dialogArrItems.push(suggestionArr[hashMapSuggestionArr[dialogIds]])
                    this.DialogsinGroups[dialogIds] = 1
                   
                }
            }
            dialogGroupArrItem.dlgs = dialogArrItems
            dialogGroupArr.push(dialogGroupArrItem)
        }
        this.checkOthersAndMake(dialogGroupArr,suggestionArr)
        dialogGroupArr = this.checkEmptyGrps(dialogGroupArr)
        return dialogGroupArr    
    }

    checkOthersAndMake = (dialogGroupArr:any,suggestionArr:any) =>{

        let OthersDialogsArr:any = [];

        suggestionArr.map((items:any,index:any)=>{
            if(!(items?.taskRefId in this.DialogsinGroups)){
                OthersDialogsArr.push(items)                
            }
        }
        )

        if(OthersDialogsArr.length>0){
            let OthersGroup:any = {
            "gn": "Others"
        };
            OthersGroup.dlgs = OthersDialogsArr
            dialogGroupArr.push(OthersGroup)
        }
    }
        
    fetchSummaries = (hostInstance : any) => {
        if(this.isSummariesGenerated){
          return;
        }
        const payload = {
          conversationId : this.connectionDetails.conversationId,
          botId : this.connectionDetails.botId,
          participant : this?.internalTransferData?.participant || {}
        }
        hostInstance.socketConnection.emitEvents(EVENTS.get_summaries, payload);
    }

    checkDynamicTasksAndFilter = (hostIns:any,typedText:string) =>{
        const menuResponse = typeof structuredClone === 'function' 
        ? structuredClone(this.menuResponseArr) 
        : JSON.parse(JSON.stringify(this.menuResponseArr));
        const filterItems = menuResponse.filter((obj:any) => obj?.intentName.toLowerCase().includes(typedText.toLowerCase()))
        return filterItems;
    }
        

    checkEmptyGrps = (dialogGroupArr:any) =>{
        return dialogGroupArr.filter((obj:any) => obj?.dlgs?.length>0)       
    }

}


export default rootService;
